import Bs, { isAxiosError as El } from "axios";
import { useMemo as wl } from "react";
var Ot = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ga(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
var X = function(r) {
  try {
    return !!r();
  } catch {
    return !0;
  }
}, Il = X, Je = !Il(function() {
  var r = (function() {
  }).bind();
  return typeof r != "function" || r.hasOwnProperty("prototype");
}), Us = Je, Ks = Function.prototype, Kn = Ks.call, Pl = Us && Ks.bind.bind(Kn, Kn), V = Us ? Pl : function(r) {
  return function() {
    return Kn.apply(r, arguments);
  };
}, Rl = V, Xe = Rl({}.isPrototypeOf), me = function(r) {
  return r && r.Math === Math && r;
}, tr = (
  // eslint-disable-next-line es/no-global-this -- safe
  me(typeof globalThis == "object" && globalThis) || me(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
  me(typeof self == "object" && self) || me(typeof Ot == "object" && Ot) || // eslint-disable-next-line no-new-func -- fallback
  /* @__PURE__ */ function() {
    return this;
  }() || Ot || Function("return this")()
), Cl = Je, Gs = Function.prototype, so = Gs.apply, co = Gs.call, Al = typeof Reflect == "object" && Reflect.apply || (Cl ? co.bind(so) : function() {
  return co.apply(so, arguments);
}), Vs = V, Dl = Vs({}.toString), jl = Vs("".slice), Qe = function(r) {
  return jl(Dl(r), 8, -1);
}, xl = Qe, Nl = V, ma = function(r) {
  if (xl(r) === "Function") return Nl(r);
}, Gn = typeof document == "object" && document.all, kl = typeof Gn > "u" && Gn !== void 0, Ws = {
  all: Gn,
  IS_HTMLDDA: kl
}, Ys = Ws, Ml = Ys.all, W = Ys.IS_HTMLDDA ? function(r) {
  return typeof r == "function" || r === Ml;
} : function(r) {
  return typeof r == "function";
}, Hs = {}, Ll = X, re = !Ll(function() {
  return Object.defineProperty({}, 1, { get: function() {
    return 7;
  } })[1] !== 7;
}), Fl = Je, be = Function.prototype.call, ba = Fl ? be.bind(be) : function() {
  return be.apply(be, arguments);
}, qs = {}, zs = {}.propertyIsEnumerable, Js = Object.getOwnPropertyDescriptor, Bl = Js && !zs.call({ 1: 2 }, 1);
qs.f = Bl ? function(e) {
  var t = Js(this, e);
  return !!t && t.enumerable;
} : zs;
var Xs = function(r, e) {
  return {
    enumerable: !(r & 1),
    configurable: !(r & 2),
    writable: !(r & 4),
    value: e
  };
}, Ul = V, Kl = X, Gl = Qe, _t = Object, Vl = Ul("".split), Qs = Kl(function() {
  return !_t("z").propertyIsEnumerable(0);
}) ? function(r) {
  return Gl(r) === "String" ? Vl(r, "") : _t(r);
} : _t, Zs = function(r) {
  return r == null;
}, Wl = Zs, Yl = TypeError, Ze = function(r) {
  if (Wl(r)) throw Yl("Can't call method on " + r);
  return r;
}, Hl = Qs, ql = Ze, rc = function(r) {
  return Hl(ql(r));
}, uo = W, ec = Ws, zl = ec.all, ee = ec.IS_HTMLDDA ? function(r) {
  return typeof r == "object" ? r !== null : uo(r) || r === zl;
} : function(r) {
  return typeof r == "object" ? r !== null : uo(r);
}, Sa = {}, Tt = Sa, Et = tr, Jl = W, lo = function(r) {
  return Jl(r) ? r : void 0;
}, tc = function(r, e) {
  return arguments.length < 2 ? lo(Tt[r]) || lo(Et[r]) : Tt[r] && Tt[r][e] || Et[r] && Et[r][e];
}, Xl = typeof navigator < "u" && String(navigator.userAgent) || "", nc = tr, wt = Xl, vo = nc.process, fo = nc.Deno, po = vo && vo.versions || fo && fo.version, $o = po && po.v8, L, Ge;
$o && (L = $o.split("."), Ge = L[0] > 0 && L[0] < 4 ? 1 : +(L[0] + L[1]));
!Ge && wt && (L = wt.match(/Edge\/(\d+)/), (!L || L[1] >= 74) && (L = wt.match(/Chrome\/(\d+)/), L && (Ge = +L[1])));
var Ql = Ge, ho = Ql, Zl = X, rv = tr, ev = rv.String, ac = !!Object.getOwnPropertySymbols && !Zl(function() {
  var r = Symbol("symbol detection");
  return !ev(r) || !(Object(r) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
  !Symbol.sham && ho && ho < 41;
}), tv = ac, oc = tv && !Symbol.sham && typeof Symbol.iterator == "symbol", nv = tc, av = W, ov = Xe, iv = oc, sv = Object, ic = iv ? function(r) {
  return typeof r == "symbol";
} : function(r) {
  var e = nv("Symbol");
  return av(e) && ov(e.prototype, sv(r));
}, cv = String, uv = function(r) {
  try {
    return cv(r);
  } catch {
    return "Object";
  }
}, lv = W, vv = uv, fv = TypeError, sc = function(r) {
  if (lv(r)) return r;
  throw fv(vv(r) + " is not a function");
}, dv = sc, pv = Zs, $v = function(r, e) {
  var t = r[e];
  return pv(t) ? void 0 : dv(t);
}, It = ba, Pt = W, Rt = ee, hv = TypeError, yv = function(r, e) {
  var t, n;
  if (e === "string" && Pt(t = r.toString) && !Rt(n = It(t, r)) || Pt(t = r.valueOf) && !Rt(n = It(t, r)) || e !== "string" && Pt(t = r.toString) && !Rt(n = It(t, r))) return n;
  throw hv("Can't convert object to primitive value");
}, cc = { exports: {} }, yo = tr, gv = Object.defineProperty, mv = function(r, e) {
  try {
    gv(yo, r, { value: e, configurable: !0, writable: !0 });
  } catch {
    yo[r] = e;
  }
  return e;
}, bv = tr, Sv = mv, go = "__core-js_shared__", Ov = bv[go] || Sv(go, {}), uc = Ov, mo = uc;
(cc.exports = function(r, e) {
  return mo[r] || (mo[r] = e !== void 0 ? e : {});
})("versions", []).push({
  version: "3.32.1",
  mode: "pure",
  copyright: "© 2014-2023 Denis Pushkarev (zloirock.ru)",
  license: "https://github.com/zloirock/core-js/blob/v3.32.1/LICENSE",
  source: "https://github.com/zloirock/core-js"
});
var _v = cc.exports, Tv = Ze, Ev = Object, lc = function(r) {
  return Ev(Tv(r));
}, wv = V, Iv = lc, Pv = wv({}.hasOwnProperty), Oa = Object.hasOwn || function(e, t) {
  return Pv(Iv(e), t);
}, Rv = V, Cv = 0, Av = Math.random(), Dv = Rv(1 .toString), jv = function(r) {
  return "Symbol(" + (r === void 0 ? "" : r) + ")_" + Dv(++Cv + Av, 36);
}, xv = tr, Nv = _v, bo = Oa, kv = jv, Mv = ac, Lv = oc, br = xv.Symbol, Ct = Nv("wks"), Fv = Lv ? br.for || br : br && br.withoutSetter || kv, Dr = function(r) {
  return bo(Ct, r) || (Ct[r] = Mv && bo(br, r) ? br[r] : Fv("Symbol." + r)), Ct[r];
}, Bv = ba, So = ee, Oo = ic, Uv = $v, Kv = yv, Gv = Dr, Vv = TypeError, Wv = Gv("toPrimitive"), Yv = function(r, e) {
  if (!So(r) || Oo(r)) return r;
  var t = Uv(r, Wv), n;
  if (t) {
    if (e === void 0 && (e = "default"), n = Bv(t, r, e), !So(n) || Oo(n)) return n;
    throw Vv("Can't convert object to primitive value");
  }
  return e === void 0 && (e = "number"), Kv(r, e);
}, Hv = Yv, qv = ic, vc = function(r) {
  var e = Hv(r, "string");
  return qv(e) ? e : e + "";
}, zv = tr, _o = ee, Vn = zv.document, Jv = _o(Vn) && _o(Vn.createElement), Xv = function(r) {
  return Jv ? Vn.createElement(r) : {};
}, Qv = re, Zv = X, rf = Xv, fc = !Qv && !Zv(function() {
  return Object.defineProperty(rf("div"), "a", {
    get: function() {
      return 7;
    }
  }).a !== 7;
}), ef = re, tf = ba, nf = qs, af = Xs, of = rc, sf = vc, cf = Oa, uf = fc, To = Object.getOwnPropertyDescriptor;
Hs.f = ef ? To : function(e, t) {
  if (e = of(e), t = sf(t), uf) try {
    return To(e, t);
  } catch {
  }
  if (cf(e, t)) return af(!tf(nf.f, e, t), e[t]);
};
var lf = X, vf = W, ff = /#|\.prototype\./, te = function(r, e) {
  var t = pf[df(r)];
  return t === hf ? !0 : t === $f ? !1 : vf(e) ? lf(e) : !!e;
}, df = te.normalize = function(r) {
  return String(r).replace(ff, ".").toLowerCase();
}, pf = te.data = {}, $f = te.NATIVE = "N", hf = te.POLYFILL = "P", yf = te, Eo = ma, gf = sc, mf = Je, bf = Eo(Eo.bind), dc = function(r, e) {
  return gf(r), e === void 0 ? r : mf ? bf(r, e) : function() {
    return r.apply(e, arguments);
  };
}, pc = {}, Sf = re, Of = X, _f = Sf && Of(function() {
  return Object.defineProperty(function() {
  }, "prototype", {
    value: 42,
    writable: !1
  }).prototype !== 42;
}), Tf = ee, Ef = String, wf = TypeError, If = function(r) {
  if (Tf(r)) return r;
  throw wf(Ef(r) + " is not an object");
}, Pf = re, Rf = fc, Cf = _f, Se = If, wo = vc, Af = TypeError, At = Object.defineProperty, Df = Object.getOwnPropertyDescriptor, Dt = "enumerable", jt = "configurable", xt = "writable";
pc.f = Pf ? Cf ? function(e, t, n) {
  if (Se(e), t = wo(t), Se(n), typeof e == "function" && t === "prototype" && "value" in n && xt in n && !n[xt]) {
    var a = Df(e, t);
    a && a[xt] && (e[t] = n.value, n = {
      configurable: jt in n ? n[jt] : a[jt],
      enumerable: Dt in n ? n[Dt] : a[Dt],
      writable: !1
    });
  }
  return At(e, t, n);
} : At : function(e, t, n) {
  if (Se(e), t = wo(t), Se(n), Rf) try {
    return At(e, t, n);
  } catch {
  }
  if ("get" in n || "set" in n) throw Af("Accessors not supported");
  return "value" in n && (e[t] = n.value), e;
};
var jf = re, xf = pc, Nf = Xs, kf = jf ? function(r, e, t) {
  return xf.f(r, e, Nf(1, t));
} : function(r, e, t) {
  return r[e] = t, r;
}, Oe = tr, Mf = Al, Lf = ma, Ff = W, Bf = Hs.f, Uf = yf, dr = Sa, Kf = dc, pr = kf, Io = Oa, Gf = function(r) {
  var e = function(t, n, a) {
    if (this instanceof e) {
      switch (arguments.length) {
        case 0:
          return new r();
        case 1:
          return new r(t);
        case 2:
          return new r(t, n);
      }
      return new r(t, n, a);
    }
    return Mf(r, this, arguments);
  };
  return e.prototype = r.prototype, e;
}, rt = function(r, e) {
  var t = r.target, n = r.global, a = r.stat, o = r.proto, i = n ? Oe : a ? Oe[t] : (Oe[t] || {}).prototype, s = n ? dr : dr[t] || pr(dr, t, {})[t], l = s.prototype, c, u, v, f, d, p, y, $, b;
  for (f in e)
    c = Uf(n ? f : t + (a ? "." : "#") + f, r.forced), u = !c && i && Io(i, f), p = s[f], u && (r.dontCallGetSet ? (b = Bf(i, f), y = b && b.value) : y = i[f]), d = u && y ? y : e[f], !(u && typeof p == typeof d) && (r.bind && u ? $ = Kf(d, Oe) : r.wrap && u ? $ = Gf(d) : o && Ff(d) ? $ = Lf(d) : $ = d, (r.sham || d && d.sham || p && p.sham) && pr($, "sham", !0), pr(s, f, $), o && (v = t + "Prototype", Io(dr, v) || pr(dr, v, {}), pr(dr[v], f, d), r.real && l && (c || !l[f]) && pr(l, f, d)));
}, Vf = Math.ceil, Wf = Math.floor, Yf = Math.trunc || function(e) {
  var t = +e;
  return (t > 0 ? Wf : Vf)(t);
}, Hf = Yf, $c = function(r) {
  var e = +r;
  return e !== e || e === 0 ? 0 : Hf(e);
}, qf = $c, zf = Math.max, Jf = Math.min, Xf = function(r, e) {
  var t = qf(r);
  return t < 0 ? zf(t + e, 0) : Jf(t, e);
}, Qf = $c, Zf = Math.min, hc = function(r) {
  return r > 0 ? Zf(Qf(r), 9007199254740991) : 0;
}, rd = hc, yc = function(r) {
  return rd(r.length);
}, ed = rc, td = Xf, nd = yc, ad = function(r) {
  return function(e, t, n) {
    var a = ed(e), o = nd(a), i = td(n, o), s;
    if (t !== t) {
      for (; o > i; )
        if (s = a[i++], s !== s) return !0;
    } else for (; o > i; i++)
      if (a[i] === t) return r;
    return !r;
  };
}, od = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: ad(!0)
}, id = rt, sd = od.includes, cd = X, ud = cd(function() {
  return !Array(1).includes();
});
id({ target: "Array", proto: !0, forced: ud }, {
  includes: function(e) {
    return sd(this, e, arguments.length > 1 ? arguments[1] : void 0);
  }
});
var ld = Sa, et = function(r) {
  return ld[r + "Prototype"];
}, vd = et, fd = vd("Array").includes, dd = ee, pd = Qe, $d = Dr, hd = $d("match"), yd = function(r) {
  var e;
  return dd(r) && ((e = r[hd]) !== void 0 ? !!e : pd(r) === "RegExp");
}, gd = yd, md = TypeError, gc = function(r) {
  if (gd(r))
    throw md("The method doesn't accept regular expressions");
  return r;
}, bd = Dr, Sd = bd("toStringTag"), mc = {};
mc[Sd] = "z";
var Od = String(mc) === "[object z]", _d = Od, Td = W, Me = Qe, Ed = Dr, wd = Ed("toStringTag"), Id = Object, Pd = Me(/* @__PURE__ */ function() {
  return arguments;
}()) === "Arguments", Rd = function(r, e) {
  try {
    return r[e];
  } catch {
  }
}, bc = _d ? Me : function(r) {
  var e, t, n;
  return r === void 0 ? "Undefined" : r === null ? "Null" : typeof (t = Rd(e = Id(r), wd)) == "string" ? t : Pd ? Me(e) : (n = Me(e)) === "Object" && Td(e.callee) ? "Arguments" : n;
}, Cd = bc, Ad = String, Sc = function(r) {
  if (Cd(r) === "Symbol") throw TypeError("Cannot convert a Symbol value to a string");
  return Ad(r);
}, Dd = Dr, jd = Dd("match"), Oc = function(r) {
  var e = /./;
  try {
    "/./"[r](e);
  } catch {
    try {
      return e[jd] = !1, "/./"[r](e);
    } catch {
    }
  }
  return !1;
}, xd = rt, Nd = V, kd = gc, Md = Ze, Po = Sc, Ld = Oc, Fd = Nd("".indexOf);
xd({ target: "String", proto: !0, forced: !Ld("includes") }, {
  includes: function(e) {
    return !!~Fd(
      Po(Md(this)),
      Po(kd(e)),
      arguments.length > 1 ? arguments[1] : void 0
    );
  }
});
var Bd = et, Ud = Bd("String").includes, Ro = Xe, Kd = fd, Gd = Ud, Nt = Array.prototype, kt = String.prototype, Vd = function(r) {
  var e = r.includes;
  return r === Nt || Ro(Nt, r) && e === Nt.includes ? Kd : typeof r == "string" || r === kt || Ro(kt, r) && e === kt.includes ? Gd : e;
}, Wd = Vd, Yd = Wd, Hd = Yd, Ur = /* @__PURE__ */ ga(Hd), qd = V, zd = W, Wn = uc, Jd = qd(Function.toString);
zd(Wn.inspectSource) || (Wn.inspectSource = function(r) {
  return Jd(r);
});
var Xd = Wn.inspectSource, Qd = V, Zd = X, _c = W, rp = bc, ep = tc, tp = Xd, Tc = function() {
}, np = [], Ec = ep("Reflect", "construct"), _a = /^\s*(?:class|function)\b/, ap = Qd(_a.exec), op = !_a.exec(Tc), Kr = function(e) {
  if (!_c(e)) return !1;
  try {
    return Ec(Tc, np, e), !0;
  } catch {
    return !1;
  }
}, wc = function(e) {
  if (!_c(e)) return !1;
  switch (rp(e)) {
    case "AsyncFunction":
    case "GeneratorFunction":
    case "AsyncGeneratorFunction":
      return !1;
  }
  try {
    return op || !!ap(_a, tp(e));
  } catch {
    return !0;
  }
};
wc.sham = !0;
!Ec || Zd(function() {
  var r;
  return Kr(Kr.call) || !Kr(Object) || !Kr(function() {
    r = !0;
  }) || r;
});
var ip = Dr;
ip("species");
var sp = dc, cp = V, up = Qs, lp = lc, vp = yc, Co = cp([].push), fp = function(r) {
  return function(e, t, n, a) {
    for (var o = lp(e), i = up(o), s = sp(t, n), l = vp(i), c = 0, u = void 0, v, f; l > c; c++)
      if (v = i[c], f = s(v, c, o), f) switch (r) {
        case 3:
          return !0;
        // some
        case 5:
          return v;
        // find
        case 6:
          return c;
        // findIndex
        case 2:
          Co(u, v);
      }
      else switch (r) {
        case 4:
          return !1;
        // every
        case 7:
          Co(u, v);
      }
    return u;
  };
}, dp = {
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: fp(5)
}, pp = rt, $p = dp.find, Ao = "find", Ic = !0;
Ao in [] && Array(1)[Ao](function() {
  Ic = !1;
});
pp({ target: "Array", proto: !0, forced: Ic }, {
  find: function(e) {
    return $p(this, e, arguments.length > 1 ? arguments[1] : void 0);
  }
});
var hp = et, yp = hp("Array").find, gp = Xe, mp = yp, Mt = Array.prototype, bp = function(r) {
  var e = r.find;
  return r === Mt || gp(Mt, r) && e === Mt.find ? mp : e;
}, Sp = bp, Op = Sp, _p = Op, Tp = /* @__PURE__ */ ga(_p), Ep = rt, Pc = ma, wp = hc, Do = Sc, Ip = gc, Pp = Ze, Rp = Oc, jo = Pc("".startsWith), Cp = Pc("".slice), Ap = Math.min, Dp = Rp("startsWith");
Ep({ target: "String", proto: !0, forced: !Dp }, {
  startsWith: function(e) {
    var t = Do(Pp(this));
    Ip(e);
    var n = wp(Ap(arguments.length > 1 ? arguments[1] : void 0, t.length)), a = Do(e);
    return jo ? jo(t, a, n) : Cp(t, n, n + a.length) === a;
  }
});
var jp = et, xp = jp("String").startsWith, Np = Xe, kp = xp, Lt = String.prototype, Mp = function(r) {
  var e = r.startsWith;
  return typeof r == "string" || r === Lt || Np(Lt, r) && e === Lt.startsWith ? kp : e;
}, Lp = Mp, Fp = Lp, Bp = Fp, Up = /* @__PURE__ */ ga(Bp);
function xo(r) {
  r = r.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
  const t = new RegExp(`[\\?&]${r}=([^&#]*)`).exec(location.search);
  return t === null ? null : Kp(t[1].replace(/\+/g, " "));
}
function Kp(r) {
  try {
    return decodeURIComponent(r);
  } catch {
    return console.warn(`Failed to decode param value '${r}'`), r;
  }
}
const Rc = {
  backendDomain: "dixa:backend-domain"
};
function Gp() {
  const r = xo("staging") || xo("backend-domain");
  if (r) {
    const e = /^\d+$/.test(r) ? `euw1.stag${r === "1" ? "" : r}.dixa.io` : r;
    return Wp(e), e;
  }
  return null;
}
function Vp() {
  var r;
  const e = Tp(r = document.cookie.split("; ")).call(r, (t) => Up(t).call(t, `${Rc.backendDomain}=`));
  return e ? decodeURIComponent(e.split("=")[1]) : null;
}
function Wp(r) {
  document.cookie = `${Rc.backendDomain}=${encodeURIComponent(r)}; path=/; max-age=31536000; SameSite=Lax`;
}
var No, ko, Mo, Ft, Bt, Ut, Kt, Gt, Vt, Wt, Yt;
const ir = {
  restApiUrl: "_dixa-rest-api-url",
  partnerIntegrationsApiUrl: "_dixa-partner-integrations-api-url",
  filesApiUrl: "_dixa-files-api-url",
  loginUrl: "_dixa-login-url",
  signUpUrl: "_dixa-sign-up-url",
  subdomain: "_dixa-subdomain",
  webSocketUrl: "_dixa-websocket-url"
}, Ht = window.location.origin.replace(/^https?:\/\//, ""), h = (Ft = Gp()) !== null && Ft !== void 0 ? Ft : Vp(), m = {
  // The development domains.
  develop: ["localhost:8080", "dixadev.com", "dixa.io"],
  // The testing domains.
  test: {
    // The security testing domains.
    security: ["dixa-security.com", "dixa-security.net"],
    // The automation testing domains.
    automation: ["localhost:9999", "test-agent-interface.dixa.io", "test.dixatest.com", "okta-test-org.dixatest.com"]
  },
  // The custom subdomains.
  custom: ["thehaddaway.dixa.com", "demo.dixa.com", "developer.dixa.com", "okta-test.dixa.com", "development.dixa.com", "engineering.dixa.com"],
  default: {
    email: "dixa.com",
    emailIntegration: "email.dixa.io",
    integrations: "docs.dixa.io",
    service: "dixa.io",
    status: "status.dixa.io",
    subdomain: (Bt = localStorage.getItem(ir.subdomain)) !== null && Bt !== void 0 ? Bt : "demo",
    userContent: "dixausercontent.com",
    web: "dixa.com",
    accounts: "accounts.dixa.com",
    knowledge: "knowledge-backend-cdn"
  }
}, Yp = {
  assets: `https://assets.${m.default.service}`,
  toolkit: `https://toolkit.${m.default.service}`,
  widget: `https://widget.${m.default.service}`,
  rest: (Ut = localStorage.getItem(ir.restApiUrl)) !== null && Ut !== void 0 ? Ut : `https://api.${h ?? m.default.service}`,
  partnerIntegrations: (Kt = localStorage.getItem(ir.partnerIntegrationsApiUrl)) !== null && Kt !== void 0 ? Kt : `https://partner-integrations.${h ?? m.default.service}`,
  files: (Gt = localStorage.getItem(ir.filesApiUrl)) !== null && Gt !== void 0 ? Gt : `https://files.${h ?? m.default.service}`,
  webSocket: (Vt = localStorage.getItem(ir.webSocketUrl)) !== null && Vt !== void 0 ? Vt : `wss://agent-sockets.${h ?? m.default.service}/v2/agent/`,
  userContent: h ? `https://raw.${h.replace(m.default.service, m.default.userContent)}` : `https://raw.${m.default.userContent}`,
  signUp: (Wt = localStorage.getItem(ir.signUpUrl)) !== null && Wt !== void 0 ? Wt : `https://${m.default.accounts}/signup`,
  logIn: (Yt = localStorage.getItem(ir.loginUrl)) !== null && Yt !== void 0 ? Yt : `https://${m.default.accounts}/signin`,
  smartConversationReply: Yn(h) === "prod" ? `https://knowledge-backend-cdn.${m.default.service}` : `https://knowledge-backend-cdn.stag.${m.default.service}`,
  dixaKnowledgeBackend: Yn(h) === "prod" ? `https://knowledge-backend.${m.default.service}` : `https://knowledge-backend.stag.${m.default.service}`
}, Hp = {
  amplitude: {
    environment: Ur(No = [...m.test.automation, ...m.develop, ...m.test.security, ...m.custom]).call(No, Ht) || h != null && Ur(h).call(h, ".stag") || h != null && Ur(h).call(h, ".dev") ? "stag" : "prod"
  },
  launchDarkly: Ur(ko = m.develop).call(ko, Ht) ? "5ccbf1bfa9046808225e3998" : "5ccbf1bfa9046808225e3999",
  stripe: Ur(Mo = m.develop).call(Mo, Ht) ? "pk_test_jNReMBzv4cyXIBkSUrqaFtd0" : "pk_live_0b40LYRePjPZTtN9E9NbKixl",
  elevio: "599d54aacd7bd",
  birdeatsbug: "eee2fdfc-e7ee-4698-95fd-20e8cb83a4d5",
  jabra: {
    partnerKey: "4d2f-9cba7bbd-a9dd-4703-9847-c70a7df516ba",
    appId: "Dixa",
    appName: "Dixa"
  }
};
function Yn(r) {
  const e = r?.match(/(dev|stag\d?)/);
  return !e || e.length < 2 ? "prod" : e[1];
}
const qr = {
  environment: Yn(h),
  domain: m.default,
  sdk: Hp,
  url: Yp,
  backendDomain: h
};
var qt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function qp(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
var _e = function(r) {
  return r && r.Math === Math && r;
}, T = (
  // eslint-disable-next-line es/no-global-this -- safe
  _e(typeof globalThis == "object" && globalThis) || _e(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
  _e(typeof self == "object" && self) || _e(typeof qt == "object" && qt) || // eslint-disable-next-line no-new-func -- fallback
  /* @__PURE__ */ function() {
    return this;
  }() || qt || Function("return this")()
), S = function(r) {
  try {
    return !!r();
  } catch {
    return !0;
  }
}, zp = S, tt = !zp(function() {
  var r = (function() {
  }).bind();
  return typeof r != "function" || r.hasOwnProperty("prototype");
}), Jp = tt, Cc = Function.prototype, Lo = Cc.apply, Fo = Cc.call, Ta = typeof Reflect == "object" && Reflect.apply || (Jp ? Fo.bind(Lo) : function() {
  return Fo.apply(Lo, arguments);
}), Ac = tt, Dc = Function.prototype, Hn = Dc.call, Xp = Ac && Dc.bind.bind(Hn, Hn), E = Ac ? Xp : function(r) {
  return function() {
    return Hn.apply(r, arguments);
  };
}, jc = E, Qp = jc({}.toString), Zp = jc("".slice), vr = function(r) {
  return Zp(Qp(r), 8, -1);
}, r$ = vr, e$ = E, Ea = function(r) {
  if (r$(r) === "Function") return e$(r);
}, qn = typeof document == "object" && document.all, t$ = typeof qn > "u" && qn !== void 0, xc = {
  all: qn,
  IS_HTMLDDA: t$
}, Nc = xc, n$ = Nc.all, _ = Nc.IS_HTMLDDA ? function(r) {
  return typeof r == "function" || r === n$;
} : function(r) {
  return typeof r == "function";
}, jr = {}, a$ = S, x = !a$(function() {
  return Object.defineProperty({}, 1, { get: function() {
    return 7;
  } })[1] !== 7;
}), o$ = tt, Te = Function.prototype.call, R = o$ ? Te.bind(Te) : function() {
  return Te.apply(Te, arguments);
}, nt = {}, kc = {}.propertyIsEnumerable, Mc = Object.getOwnPropertyDescriptor, i$ = Mc && !kc.call({ 1: 2 }, 1);
nt.f = i$ ? function(e) {
  var t = Mc(this, e);
  return !!t && t.enumerable;
} : kc;
var fr = function(r, e) {
  return {
    enumerable: !(r & 1),
    configurable: !(r & 2),
    writable: !(r & 4),
    value: e
  };
}, s$ = E, c$ = S, u$ = vr, zt = Object, l$ = s$("".split), wa = c$(function() {
  return !zt("z").propertyIsEnumerable(0);
}) ? function(r) {
  return u$(r) === "String" ? l$(r, "") : zt(r);
} : zt, at = function(r) {
  return r == null;
}, v$ = at, f$ = TypeError, Ia = function(r) {
  if (v$(r)) throw f$("Can't call method on " + r);
  return r;
}, d$ = wa, p$ = Ia, Q = function(r) {
  return d$(p$(r));
}, Bo = _, Lc = xc, $$ = Lc.all, N = Lc.IS_HTMLDDA ? function(r) {
  return typeof r == "object" ? r !== null : Bo(r) || r === $$;
} : function(r) {
  return typeof r == "object" ? r !== null : Bo(r);
}, k = {}, Jt = k, Xt = T, h$ = _, Uo = function(r) {
  return h$(r) ? r : void 0;
}, M = function(r, e) {
  return arguments.length < 2 ? Uo(Jt[r]) || Uo(Xt[r]) : Jt[r] && Jt[r][e] || Xt[r] && Xt[r][e];
}, y$ = E, ne = y$({}.isPrototypeOf), ot = typeof navigator < "u" && String(navigator.userAgent) || "", Fc = T, Qt = ot, Ko = Fc.process, Go = Fc.Deno, Vo = Ko && Ko.versions || Go && Go.version, Wo = Vo && Vo.v8, F, Ve;
Wo && (F = Wo.split("."), Ve = F[0] > 0 && F[0] < 4 ? 1 : +(F[0] + F[1]));
!Ve && Qt && (F = Qt.match(/Edge\/(\d+)/), (!F || F[1] >= 74) && (F = Qt.match(/Chrome\/(\d+)/), F && (Ve = +F[1])));
var it = Ve, Yo = it, g$ = S, m$ = T, b$ = m$.String, xr = !!Object.getOwnPropertySymbols && !g$(function() {
  var r = Symbol("symbol detection");
  return !b$(r) || !(Object(r) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
  !Symbol.sham && Yo && Yo < 41;
}), S$ = xr, Bc = S$ && !Symbol.sham && typeof Symbol.iterator == "symbol", O$ = M, _$ = _, T$ = ne, E$ = Bc, w$ = Object, st = E$ ? function(r) {
  return typeof r == "symbol";
} : function(r) {
  var e = O$("Symbol");
  return _$(e) && T$(e.prototype, w$(r));
}, I$ = String, ae = function(r) {
  try {
    return I$(r);
  } catch {
    return "Object";
  }
}, P$ = _, R$ = ae, C$ = TypeError, Y = function(r) {
  if (P$(r)) return r;
  throw C$(R$(r) + " is not a function");
}, A$ = Y, D$ = at, Pa = function(r, e) {
  var t = r[e];
  return D$(t) ? void 0 : A$(t);
}, Zt = R, rn = _, en = N, j$ = TypeError, x$ = function(r, e) {
  var t, n;
  if (e === "string" && rn(t = r.toString) && !en(n = Zt(t, r)) || rn(t = r.valueOf) && !en(n = Zt(t, r)) || e !== "string" && rn(t = r.toString) && !en(n = Zt(t, r))) return n;
  throw j$("Can't convert object to primitive value");
}, Uc = { exports: {} }, N$ = !0, Ho = T, k$ = Object.defineProperty, M$ = function(r, e) {
  try {
    k$(Ho, r, { value: e, configurable: !0, writable: !0 });
  } catch {
    Ho[r] = e;
  }
  return e;
}, L$ = T, F$ = M$, qo = "__core-js_shared__", B$ = L$[qo] || F$(qo, {}), Ra = B$, zo = Ra;
(Uc.exports = function(r, e) {
  return zo[r] || (zo[r] = e !== void 0 ? e : {});
})("versions", []).push({
  version: "3.32.1",
  mode: "pure",
  copyright: "© 2014-2023 Denis Pushkarev (zloirock.ru)",
  license: "https://github.com/zloirock/core-js/blob/v3.32.1/LICENSE",
  source: "https://github.com/zloirock/core-js"
});
var oe = Uc.exports, U$ = Ia, K$ = Object, Nr = function(r) {
  return K$(U$(r));
}, G$ = E, V$ = Nr, W$ = G$({}.hasOwnProperty), A = Object.hasOwn || function(e, t) {
  return W$(V$(e), t);
}, Y$ = E, H$ = 0, q$ = Math.random(), z$ = Y$(1 .toString), Ca = function(r) {
  return "Symbol(" + (r === void 0 ? "" : r) + ")_" + z$(++H$ + q$, 36);
}, J$ = T, X$ = oe, Jo = A, Q$ = Ca, Z$ = xr, rh = Bc, Sr = J$.Symbol, tn = X$("wks"), eh = rh ? Sr.for || Sr : Sr && Sr.withoutSetter || Q$, O = function(r) {
  return Jo(tn, r) || (tn[r] = Z$ && Jo(Sr, r) ? Sr[r] : eh("Symbol." + r)), tn[r];
}, th = R, Xo = N, Qo = st, nh = Pa, ah = x$, oh = O, ih = TypeError, sh = oh("toPrimitive"), ch = function(r, e) {
  if (!Xo(r) || Qo(r)) return r;
  var t = nh(r, sh), n;
  if (t) {
    if (e === void 0 && (e = "default"), n = th(t, r, e), !Xo(n) || Qo(n)) return n;
    throw ih("Can't convert object to primitive value");
  }
  return e === void 0 && (e = "number"), ah(r, e);
}, uh = ch, lh = st, ct = function(r) {
  var e = uh(r, "string");
  return lh(e) ? e : e + "";
}, vh = T, Zo = N, zn = vh.document, fh = Zo(zn) && Zo(zn.createElement), Aa = function(r) {
  return fh ? zn.createElement(r) : {};
}, dh = x, ph = S, $h = Aa, Kc = !dh && !ph(function() {
  return Object.defineProperty($h("div"), "a", {
    get: function() {
      return 7;
    }
  }).a !== 7;
}), hh = x, yh = R, gh = nt, mh = fr, bh = Q, Sh = ct, Oh = A, _h = Kc, ri = Object.getOwnPropertyDescriptor;
jr.f = hh ? ri : function(e, t) {
  if (e = bh(e), t = Sh(t), _h) try {
    return ri(e, t);
  } catch {
  }
  if (Oh(e, t)) return mh(!yh(gh.f, e, t), e[t]);
};
var Th = S, Eh = _, wh = /#|\.prototype\./, ie = function(r, e) {
  var t = Ph[Ih(r)];
  return t === Ch ? !0 : t === Rh ? !1 : Eh(e) ? Th(e) : !!e;
}, Ih = ie.normalize = function(r) {
  return String(r).replace(wh, ".").toLowerCase();
}, Ph = ie.data = {}, Rh = ie.NATIVE = "N", Ch = ie.POLYFILL = "P", Gc = ie, ei = Ea, Ah = Y, Dh = tt, jh = ei(ei.bind), se = function(r, e) {
  return Ah(r), e === void 0 ? r : Dh ? jh(r, e) : function() {
    return r.apply(e, arguments);
  };
}, U = {}, xh = x, Nh = S, Vc = xh && Nh(function() {
  return Object.defineProperty(function() {
  }, "prototype", {
    value: 42,
    writable: !1
  }).prototype !== 42;
}), kh = N, Mh = String, Lh = TypeError, K = function(r) {
  if (kh(r)) return r;
  throw Lh(Mh(r) + " is not an object");
}, Fh = x, Bh = Kc, Uh = Vc, Ee = K, ti = ct, Kh = TypeError, nn = Object.defineProperty, Gh = Object.getOwnPropertyDescriptor, an = "enumerable", on = "configurable", sn = "writable";
U.f = Fh ? Uh ? function(e, t, n) {
  if (Ee(e), t = ti(t), Ee(n), typeof e == "function" && t === "prototype" && "value" in n && sn in n && !n[sn]) {
    var a = Gh(e, t);
    a && a[sn] && (e[t] = n.value, n = {
      configurable: on in n ? n[on] : a[on],
      enumerable: an in n ? n[an] : a[an],
      writable: !1
    });
  }
  return nn(e, t, n);
} : nn : function(e, t, n) {
  if (Ee(e), t = ti(t), Ee(n), Bh) try {
    return nn(e, t, n);
  } catch {
  }
  if ("get" in n || "set" in n) throw Kh("Accessors not supported");
  return "value" in n && (e[t] = n.value), e;
};
var Vh = x, Wh = U, Yh = fr, nr = Vh ? function(r, e, t) {
  return Wh.f(r, e, Yh(1, t));
} : function(r, e, t) {
  return r[e] = t, r;
}, we = T, Hh = Ta, qh = Ea, zh = _, Jh = jr.f, Xh = Gc, $r = k, Qh = se, hr = nr, ni = A, Zh = function(r) {
  var e = function(t, n, a) {
    if (this instanceof e) {
      switch (arguments.length) {
        case 0:
          return new r();
        case 1:
          return new r(t);
        case 2:
          return new r(t, n);
      }
      return new r(t, n, a);
    }
    return Hh(r, this, arguments);
  };
  return e.prototype = r.prototype, e;
}, g = function(r, e) {
  var t = r.target, n = r.global, a = r.stat, o = r.proto, i = n ? we : a ? we[t] : (we[t] || {}).prototype, s = n ? $r : $r[t] || hr($r, t, {})[t], l = s.prototype, c, u, v, f, d, p, y, $, b;
  for (f in e)
    c = Xh(n ? f : t + (a ? "." : "#") + f, r.forced), u = !c && i && ni(i, f), p = s[f], u && (r.dontCallGetSet ? (b = Jh(i, f), y = b && b.value) : y = i[f]), d = u && y ? y : e[f], !(u && typeof p == typeof d) && (r.bind && u ? $ = Qh(d, we) : r.wrap && u ? $ = Zh(d) : o && zh(d) ? $ = qh(d) : $ = d, (r.sham || d && d.sham || p && p.sham) && hr($, "sham", !0), hr(s, f, $), o && (v = t + "Prototype", ni($r, v) || hr($r, v, {}), hr($r[v], f, d), r.real && l && (c || !l[f]) && hr(l, f, d)));
}, ry = E, ey = Y, ty = function(r, e, t) {
  try {
    return ry(ey(Object.getOwnPropertyDescriptor(r, e)[t]));
  } catch {
  }
}, ny = _, ay = String, oy = TypeError, iy = function(r) {
  if (typeof r == "object" || ny(r)) return r;
  throw oy("Can't set " + ay(r) + " as a prototype");
}, sy = ty, cy = K, uy = iy, Wc = Object.setPrototypeOf || ("__proto__" in {} ? function() {
  var r = !1, e = {}, t;
  try {
    t = sy(Object.prototype, "__proto__", "set"), t(e, []), r = e instanceof Array;
  } catch {
  }
  return function(a, o) {
    return cy(a), uy(o), r ? t(a, o) : a.__proto__ = o, a;
  };
}() : void 0), ly = g, vy = Wc;
ly({ target: "Object", stat: !0 }, {
  setPrototypeOf: vy
});
var fy = k;
fy.Object.setPrototypeOf;
var Da = {}, dy = Math.ceil, py = Math.floor, $y = Math.trunc || function(e) {
  var t = +e;
  return (t > 0 ? py : dy)(t);
}, hy = $y, ja = function(r) {
  var e = +r;
  return e !== e || e === 0 ? 0 : hy(e);
}, yy = ja, gy = Math.max, my = Math.min, xa = function(r, e) {
  var t = yy(r);
  return t < 0 ? gy(t + e, 0) : my(t, e);
}, by = ja, Sy = Math.min, Oy = function(r) {
  return r > 0 ? Sy(by(r), 9007199254740991) : 0;
}, _y = Oy, kr = function(r) {
  return _y(r.length);
}, Ty = Q, Ey = xa, wy = kr, Iy = function(r) {
  return function(e, t, n) {
    for (var a = Ty(e), o = wy(a), i = Ey(n, o); o > i; i++)
      if (i in a && a[i] === t) return i || 0;
    return -1;
  };
}, Yc = {
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: Iy()
}, ut = {}, Py = E, cn = A, Ry = Q, Cy = Yc.indexOf, Ay = ut, ai = Py([].push), Hc = function(r, e) {
  var t = Ry(r), n = 0, a = [], o;
  for (o in t) !cn(Ay, o) && cn(t, o) && ai(a, o);
  for (; e.length > n; ) cn(t, o = e[n++]) && (~Cy(a, o) || ai(a, o));
  return a;
}, Na = [
  "constructor",
  "hasOwnProperty",
  "isPrototypeOf",
  "propertyIsEnumerable",
  "toLocaleString",
  "toString",
  "valueOf"
], Dy = Hc, jy = Na, ka = Object.keys || function(e) {
  return Dy(e, jy);
}, xy = x, Ny = Vc, ky = U, My = K, Ly = Q, Fy = ka;
Da.f = xy && !Ny ? Object.defineProperties : function(e, t) {
  My(e);
  for (var n = Ly(t), a = Fy(t), o = a.length, i = 0, s; o > i; ) ky.f(e, s = a[i++], n[s]);
  return e;
};
var By = M, qc = By("document", "documentElement"), Uy = oe, Ky = Ca, oi = Uy("keys"), lt = function(r) {
  return oi[r] || (oi[r] = Ky(r));
}, Gy = K, Vy = Da, ii = Na, Wy = ut, Yy = qc, Hy = Aa, qy = lt, si = ">", ci = "<", Jn = "prototype", Xn = "script", zc = qy("IE_PROTO"), un = function() {
}, Jc = function(r) {
  return ci + Xn + si + r + ci + "/" + Xn + si;
}, ui = function(r) {
  r.write(Jc("")), r.close();
  var e = r.parentWindow.Object;
  return r = null, e;
}, zy = function() {
  var r = Hy("iframe"), e = "java" + Xn + ":", t;
  return r.style.display = "none", Yy.appendChild(r), r.src = String(e), t = r.contentWindow.document, t.open(), t.write(Jc("document.F=Object")), t.close(), t.F;
}, Ie, Le = function() {
  try {
    Ie = new ActiveXObject("htmlfile");
  } catch {
  }
  Le = typeof document < "u" ? document.domain && Ie ? ui(Ie) : zy() : ui(Ie);
  for (var r = ii.length; r--; ) delete Le[Jn][ii[r]];
  return Le();
};
Wy[zc] = !0;
var ce = Object.create || function(e, t) {
  var n;
  return e !== null ? (un[Jn] = Gy(e), n = new un(), un[Jn] = null, n[zc] = e) : n = Le(), t === void 0 ? n : Vy.f(n, t);
}, Jy = g, Xy = x, Qy = ce;
Jy({ target: "Object", stat: !0, sham: !Xy }, {
  create: Qy
});
var Zy = k;
Zy.Object;
var ue = {};
ue.f = Object.getOwnPropertySymbols;
var li = x, rg = E, eg = R, tg = S, ln = ka, ng = ue, ag = nt, og = Nr, ig = wa, yr = Object.assign, vi = Object.defineProperty, sg = rg([].concat), cg = !yr || tg(function() {
  if (li && yr({ b: 1 }, yr(vi({}, "a", {
    enumerable: !0,
    get: function() {
      vi(this, "b", {
        value: 3,
        enumerable: !1
      });
    }
  }), { b: 2 })).b !== 1) return !0;
  var r = {}, e = {}, t = Symbol("assign detection"), n = "abcdefghijklmnopqrst";
  return r[t] = 7, n.split("").forEach(function(a) {
    e[a] = a;
  }), yr({}, r)[t] !== 7 || ln(yr({}, e)).join("") !== n;
}) ? function(e, t) {
  for (var n = og(e), a = arguments.length, o = 1, i = ng.f, s = ag.f; a > o; )
    for (var l = ig(arguments[o++]), c = i ? sg(ln(l), i(l)) : ln(l), u = c.length, v = 0, f; u > v; )
      f = c[v++], (!li || eg(s, l, f)) && (n[f] = l[f]);
  return n;
} : yr, ug = g, fi = cg;
ug({ target: "Object", stat: !0, forced: Object.assign !== fi }, {
  assign: fi
});
var lg = k;
lg.Object.assign;
var vg = S, fg = function(r, e) {
  var t = [][r];
  return !!t && vg(function() {
    t.call(null, e || function() {
      return 1;
    }, 1);
  });
}, dg = g, pg = Ea, $g = Yc.indexOf, hg = fg, Qn = pg([].indexOf), Xc = !!Qn && 1 / Qn([1], 1, -0) < 0, yg = Xc || !hg("indexOf");
dg({ target: "Array", proto: !0, forced: yg }, {
  indexOf: function(e) {
    var t = arguments.length > 1 ? arguments[1] : void 0;
    return Xc ? Qn(this, e, t) || 0 : $g(this, e, t);
  }
});
var gg = k, Ma = function(r) {
  return gg[r + "Prototype"];
}, mg = Ma;
mg("Array").indexOf;
var bg = O, Sg = bg("toStringTag"), Qc = {};
Qc[Sg] = "z";
var La = String(Qc) === "[object z]", Og = La, _g = _, Fe = vr, Tg = O, Eg = Tg("toStringTag"), wg = Object, Ig = Fe(/* @__PURE__ */ function() {
  return arguments;
}()) === "Arguments", Pg = function(r, e) {
  try {
    return r[e];
  } catch {
  }
}, le = Og ? Fe : function(r) {
  var e, t, n;
  return r === void 0 ? "Undefined" : r === null ? "Null" : typeof (t = Pg(e = wg(r), Eg)) == "string" ? t : Ig ? Fe(e) : (n = Fe(e)) === "Object" && _g(e.callee) ? "Arguments" : n;
}, Rg = le, Cg = String, Mr = function(r) {
  if (Rg(r) === "Symbol") throw TypeError("Cannot convert a Symbol value to a string");
  return Cg(r);
}, vt = {}, Ag = Hc, Dg = Na, jg = Dg.concat("length", "prototype");
vt.f = Object.getOwnPropertyNames || function(e) {
  return Ag(e, jg);
};
var Zc = {}, xg = ct, Ng = U, kg = fr, Fa = function(r, e, t) {
  var n = xg(e);
  n in r ? Ng.f(r, n, kg(0, t)) : r[n] = t;
}, di = xa, Mg = kr, Lg = Fa, Fg = Array, Bg = Math.max, Ug = function(r, e, t) {
  for (var n = Mg(r), a = di(e, n), o = di(t === void 0 ? n : t, n), i = Fg(Bg(o - a, 0)), s = 0; a < o; a++, s++) Lg(i, s, r[a]);
  return i.length = s, i;
}, Kg = vr, Gg = Q, ru = vt.f, Vg = Ug, eu = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [], Wg = function(r) {
  try {
    return ru(r);
  } catch {
    return Vg(eu);
  }
};
Zc.f = function(e) {
  return eu && Kg(e) === "Window" ? Wg(e) : ru(Gg(e));
};
var Yg = nr, ve = function(r, e, t, n) {
  return n && n.enumerable ? r[e] = t : Yg(r, e, t), r;
}, Hg = U, tu = function(r, e, t) {
  return Hg.f(r, e, t);
}, fe = {}, qg = O;
fe.f = qg;
var pi = k, zg = A, Jg = fe, Xg = U.f, D = function(r) {
  var e = pi.Symbol || (pi.Symbol = {});
  zg(e, r) || Xg(e, r, {
    value: Jg.f(r)
  });
}, Qg = R, Zg = M, rm = O, em = ve, nu = function() {
  var r = Zg("Symbol"), e = r && r.prototype, t = e && e.valueOf, n = rm("toPrimitive");
  e && !e[n] && em(e, n, function(a) {
    return Qg(t, this);
  }, {});
}, tm = La, nm = le, am = tm ? {}.toString : function() {
  return "[object " + nm(this) + "]";
}, om = La, im = U.f, sm = nr, cm = A, um = am, lm = O, $i = lm("toStringTag"), Lr = function(r, e, t, n) {
  if (r) {
    var a = t ? r : r.prototype;
    cm(a, $i) || im(a, $i, { configurable: !0, value: e }), n && !om && sm(a, "toString", um);
  }
}, vm = T, fm = _, hi = vm.WeakMap, dm = fm(hi) && /native code/.test(String(hi)), pm = dm, au = T, $m = N, hm = nr, vn = A, fn = Ra, ym = lt, gm = ut, yi = "Object already initialized", Zn = au.TypeError, mm = au.WeakMap, We, zr, Ye, bm = function(r) {
  return Ye(r) ? zr(r) : We(r, {});
}, Sm = function(r) {
  return function(e) {
    var t;
    if (!$m(e) || (t = zr(e)).type !== r)
      throw Zn("Incompatible receiver, " + r + " required");
    return t;
  };
};
if (pm || fn.state) {
  var G = fn.state || (fn.state = new mm());
  G.get = G.get, G.has = G.has, G.set = G.set, We = function(r, e) {
    if (G.has(r)) throw Zn(yi);
    return e.facade = r, G.set(r, e), e;
  }, zr = function(r) {
    return G.get(r) || {};
  }, Ye = function(r) {
    return G.has(r);
  };
} else {
  var gr = ym("state");
  gm[gr] = !0, We = function(r, e) {
    if (vn(r, gr)) throw Zn(yi);
    return e.facade = r, hm(r, gr, e), e;
  }, zr = function(r) {
    return vn(r, gr) ? r[gr] : {};
  }, Ye = function(r) {
    return vn(r, gr);
  };
}
var ft = {
  set: We,
  get: zr,
  has: Ye,
  enforce: bm,
  getterFor: Sm
}, Om = vr, dt = Array.isArray || function(e) {
  return Om(e) === "Array";
}, _m = E, Tm = _, ra = Ra, Em = _m(Function.toString);
Tm(ra.inspectSource) || (ra.inspectSource = function(r) {
  return Em(r);
});
var ou = ra.inspectSource, wm = E, Im = S, iu = _, Pm = le, Rm = M, Cm = ou, su = function() {
}, Am = [], cu = Rm("Reflect", "construct"), Ba = /^\s*(?:class|function)\b/, Dm = wm(Ba.exec), jm = !Ba.exec(su), Gr = function(e) {
  if (!iu(e)) return !1;
  try {
    return cu(su, Am, e), !0;
  } catch {
    return !1;
  }
}, uu = function(e) {
  if (!iu(e)) return !1;
  switch (Pm(e)) {
    case "AsyncFunction":
    case "GeneratorFunction":
    case "AsyncGeneratorFunction":
      return !1;
  }
  try {
    return jm || !!Dm(Ba, Cm(e));
  } catch {
    return !0;
  }
};
uu.sham = !0;
var Ua = !cu || Im(function() {
  var r;
  return Gr(Gr.call) || !Gr(Object) || !Gr(function() {
    r = !0;
  }) || r;
}) ? uu : Gr, gi = dt, xm = Ua, Nm = N, km = O, Mm = km("species"), mi = Array, Lm = function(r) {
  var e;
  return gi(r) && (e = r.constructor, xm(e) && (e === mi || gi(e.prototype)) ? e = void 0 : Nm(e) && (e = e[Mm], e === null && (e = void 0))), e === void 0 ? mi : e;
}, Fm = Lm, Bm = function(r, e) {
  return new (Fm(r))(e === 0 ? 0 : e);
}, Um = se, Km = E, Gm = wa, Vm = Nr, Wm = kr;
Km([].push);
var Ym = function(r) {
  return function(e, t, n, a) {
    for (var o = Vm(e), i = Gm(o), s = Um(t, n), l = Wm(i), c = 0, u = void 0, v; l > c; c++) c in i && (v = i[c], s(v, c, o));
    return u;
  };
}, Hm = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: Ym()
}, pt = g, Ka = T, Ga = R, qm = E, Ir = x, Pr = xr, zm = S, w = A, Jm = ne, ea = K, $t = Q, Va = ct, Xm = Mr, ta = fr, Jr = ce, lu = ka, Qm = vt, vu = Zc, Zm = ue, fu = jr, du = U, rb = Da, pu = nt, bi = ve, eb = tu, Wa = oe, tb = lt, $u = ut, Si = Ca, nb = O, ab = fe, ob = D, ib = nu, sb = Lr, hu = ft, ht = Hm.forEach, C = tb("hidden"), yt = "Symbol", Xr = "prototype", cb = hu.set, Oi = hu.getterFor(yt), B = Object[Xr], ur = Ka.Symbol, Vr = ur && ur[Xr], ub = Ka.TypeError, dn = Ka.QObject, yu = fu.f, cr = du.f, gu = vu.f, lb = pu.f, mu = qm([].push), z = Wa("symbols"), de = Wa("op-symbols"), vb = Wa("wks"), na = !dn || !dn[Xr] || !dn[Xr].findChild, aa = Ir && zm(function() {
  return Jr(cr({}, "a", {
    get: function() {
      return cr(this, "a", { value: 7 }).a;
    }
  })).a !== 7;
}) ? function(r, e, t) {
  var n = yu(B, e);
  n && delete B[e], cr(r, e, t), n && r !== B && cr(B, e, n);
} : cr, pn = function(r, e) {
  var t = z[r] = Jr(Vr);
  return cb(t, {
    type: yt,
    tag: r,
    description: e
  }), Ir || (t.description = e), t;
}, gt = function(e, t, n) {
  e === B && gt(de, t, n), ea(e);
  var a = Va(t);
  return ea(n), w(z, a) ? (n.enumerable ? (w(e, C) && e[C][a] && (e[C][a] = !1), n = Jr(n, { enumerable: ta(0, !1) })) : (w(e, C) || cr(e, C, ta(1, {})), e[C][a] = !0), aa(e, a, n)) : cr(e, a, n);
}, Ya = function(e, t) {
  ea(e);
  var n = $t(t), a = lu(n).concat(_u(n));
  return ht(a, function(o) {
    (!Ir || Ga(bu, n, o)) && gt(e, o, n[o]);
  }), e;
}, fb = function(e, t) {
  return t === void 0 ? Jr(e) : Ya(Jr(e), t);
}, bu = function(e) {
  var t = Va(e), n = Ga(lb, this, t);
  return this === B && w(z, t) && !w(de, t) ? !1 : n || !w(this, t) || !w(z, t) || w(this, C) && this[C][t] ? n : !0;
}, Su = function(e, t) {
  var n = $t(e), a = Va(t);
  if (!(n === B && w(z, a) && !w(de, a))) {
    var o = yu(n, a);
    return o && w(z, a) && !(w(n, C) && n[C][a]) && (o.enumerable = !0), o;
  }
}, Ou = function(e) {
  var t = gu($t(e)), n = [];
  return ht(t, function(a) {
    !w(z, a) && !w($u, a) && mu(n, a);
  }), n;
}, _u = function(r) {
  var e = r === B, t = gu(e ? de : $t(r)), n = [];
  return ht(t, function(a) {
    w(z, a) && (!e || w(B, a)) && mu(n, z[a]);
  }), n;
};
Pr || (ur = function() {
  if (Jm(Vr, this)) throw ub("Symbol is not a constructor");
  var e = !arguments.length || arguments[0] === void 0 ? void 0 : Xm(arguments[0]), t = Si(e), n = function(a) {
    this === B && Ga(n, de, a), w(this, C) && w(this[C], t) && (this[C][t] = !1), aa(this, t, ta(1, a));
  };
  return Ir && na && aa(B, t, { configurable: !0, set: n }), pn(t, e);
}, Vr = ur[Xr], bi(Vr, "toString", function() {
  return Oi(this).tag;
}), bi(ur, "withoutSetter", function(r) {
  return pn(Si(r), r);
}), pu.f = bu, du.f = gt, rb.f = Ya, fu.f = Su, Qm.f = vu.f = Ou, Zm.f = _u, ab.f = function(r) {
  return pn(nb(r), r);
}, Ir && eb(Vr, "description", {
  configurable: !0,
  get: function() {
    return Oi(this).description;
  }
}));
pt({ global: !0, wrap: !0, forced: !Pr, sham: !Pr }, {
  Symbol: ur
});
ht(lu(vb), function(r) {
  ob(r);
});
pt({ target: yt, stat: !0, forced: !Pr }, {
  useSetter: function() {
    na = !0;
  },
  useSimple: function() {
    na = !1;
  }
});
pt({ target: "Object", stat: !0, forced: !Pr, sham: !Ir }, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: fb,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: gt,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: Ya,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: Su
});
pt({ target: "Object", stat: !0, forced: !Pr }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: Ou
});
ib();
sb(ur, yt);
$u[C] = !0;
var db = xr, Tu = db && !!Symbol.for && !!Symbol.keyFor, pb = g, $b = M, hb = A, yb = Mr, Eu = oe, gb = Tu, $n = Eu("string-to-symbol-registry"), mb = Eu("symbol-to-string-registry");
pb({ target: "Symbol", stat: !0, forced: !gb }, {
  for: function(r) {
    var e = yb(r);
    if (hb($n, e)) return $n[e];
    var t = $b("Symbol")(e);
    return $n[e] = t, mb[t] = e, t;
  }
});
var bb = g, Sb = A, Ob = st, _b = ae, Tb = oe, Eb = Tu, _i = Tb("symbol-to-string-registry");
bb({ target: "Symbol", stat: !0, forced: !Eb }, {
  keyFor: function(e) {
    if (!Ob(e)) throw TypeError(_b(e) + " is not a symbol");
    if (Sb(_i, e)) return _i[e];
  }
});
var wb = E, Ha = wb([].slice), Ib = E, Ti = dt, Pb = _, Ei = vr, Rb = Mr, wi = Ib([].push), Cb = function(r) {
  if (Pb(r)) return r;
  if (Ti(r)) {
    for (var e = r.length, t = [], n = 0; n < e; n++) {
      var a = r[n];
      typeof a == "string" ? wi(t, a) : (typeof a == "number" || Ei(a) === "Number" || Ei(a) === "String") && wi(t, Rb(a));
    }
    var o = t.length, i = !0;
    return function(s, l) {
      if (i)
        return i = !1, l;
      if (Ti(this)) return l;
      for (var c = 0; c < o; c++) if (t[c] === s) return l;
    };
  }
}, Ab = g, wu = M, Iu = Ta, Db = R, pe = E, Pu = S, Ii = _, Pi = st, Ru = Ha, jb = Cb, xb = xr, Nb = String, rr = wu("JSON", "stringify"), Pe = pe(/./.exec), Ri = pe("".charAt), kb = pe("".charCodeAt), Mb = pe("".replace), Lb = pe(1 .toString), Fb = /[\uD800-\uDFFF]/g, Ci = /^[\uD800-\uDBFF]$/, Ai = /^[\uDC00-\uDFFF]$/, Di = !xb || Pu(function() {
  var r = wu("Symbol")("stringify detection");
  return rr([r]) !== "[null]" || rr({ a: r }) !== "{}" || rr(Object(r)) !== "{}";
}), ji = Pu(function() {
  return rr("\uDF06\uD834") !== '"\\udf06\\ud834"' || rr("\uDEAD") !== '"\\udead"';
}), Bb = function(r, e) {
  var t = Ru(arguments), n = jb(e);
  if (!(!Ii(n) && (r === void 0 || Pi(r))))
    return t[1] = function(a, o) {
      if (Ii(n) && (o = Db(n, this, Nb(a), o)), !Pi(o)) return o;
    }, Iu(rr, null, t);
}, Ub = function(r, e, t) {
  var n = Ri(t, e - 1), a = Ri(t, e + 1);
  return Pe(Ci, r) && !Pe(Ai, a) || Pe(Ai, r) && !Pe(Ci, n) ? "\\u" + Lb(kb(r, 0), 16) : r;
};
rr && Ab({ target: "JSON", stat: !0, forced: Di || ji }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  stringify: function(e, t, n) {
    var a = Ru(arguments), o = Iu(Di ? Bb : rr, null, a);
    return ji && typeof o == "string" ? Mb(o, Fb, Ub) : o;
  }
});
var Kb = g, Gb = xr, Vb = S, Cu = ue, Wb = Nr, Yb = !Gb || Vb(function() {
  Cu.f(1);
});
Kb({ target: "Object", stat: !0, forced: Yb }, {
  getOwnPropertySymbols: function(e) {
    var t = Cu.f;
    return t ? t(Wb(e)) : [];
  }
});
var Hb = k;
Hb.Object.getOwnPropertySymbols;
var qb = g, zb = S, Jb = Q, Au = jr.f, Du = x, Xb = !Du || zb(function() {
  Au(1);
});
qb({ target: "Object", stat: !0, forced: Xb, sham: !Du }, {
  getOwnPropertyDescriptor: function(e, t) {
    return Au(Jb(e), t);
  }
});
var Qb = k, Zb = Qb.Object;
Zb.getOwnPropertyDescriptor.sham;
var rS = g, eS = x, xi = U.f;
rS({ target: "Object", stat: !0, forced: Object.defineProperty !== xi, sham: !eS }, {
  defineProperty: xi
});
var tS = k, nS = tS.Object;
nS.defineProperty.sham;
var aS = S, oS = !aS(function() {
  function r() {
  }
  return r.prototype.constructor = null, Object.getPrototypeOf(new r()) !== r.prototype;
}), iS = A, sS = _, cS = Nr, uS = lt, lS = oS, Ni = uS("IE_PROTO"), oa = Object, vS = oa.prototype, qa = lS ? oa.getPrototypeOf : function(r) {
  var e = cS(r);
  if (iS(e, Ni)) return e[Ni];
  var t = e.constructor;
  return sS(t) && e instanceof t ? t.prototype : e instanceof oa ? vS : null;
}, fS = M, dS = E, pS = vt, $S = ue, hS = K, yS = dS([].concat), gS = fS("Reflect", "ownKeys") || function(e) {
  var t = pS.f(hS(e)), n = $S.f;
  return n ? yS(t, n(e)) : t;
}, ki = A, mS = gS, bS = jr, SS = U, OS = function(r, e, t) {
  for (var n = mS(e), a = SS.f, o = bS.f, i = 0; i < n.length; i++) {
    var s = n[i];
    !ki(r, s) && !(t && ki(t, s)) && a(r, s, o(e, s));
  }
}, _S = N, TS = nr, ES = function(r, e) {
  _S(e) && "cause" in e && TS(r, "cause", e.cause);
}, wS = E, ju = Error, IS = wS("".replace), PS = function(r) {
  return String(ju(r).stack);
}("zxcasd"), xu = /\n\s*at [^:]*:[^\n]*/, RS = xu.test(PS), CS = function(r, e) {
  if (RS && typeof r == "string" && !ju.prepareStackTrace)
    for (; e--; ) r = IS(r, xu, "");
  return r;
}, AS = S, DS = fr, jS = !AS(function() {
  var r = Error("a");
  return "stack" in r ? (Object.defineProperty(r, "stack", DS(1, 7)), r.stack !== 7) : !0;
}), xS = nr, NS = CS, kS = jS, Mi = Error.captureStackTrace, MS = function(r, e, t, n) {
  kS && (Mi ? Mi(r, e) : xS(r, "stack", NS(t, n)));
}, Fr = {}, LS = O, FS = Fr, BS = LS("iterator"), US = Array.prototype, KS = function(r) {
  return r !== void 0 && (FS.Array === r || US[BS] === r);
}, GS = le, Li = Pa, VS = at, WS = Fr, YS = O, HS = YS("iterator"), Nu = function(r) {
  if (!VS(r)) return Li(r, HS) || Li(r, "@@iterator") || WS[GS(r)];
}, qS = R, zS = Y, JS = K, XS = ae, QS = Nu, ZS = TypeError, r1 = function(r, e) {
  var t = arguments.length < 2 ? QS(r) : e;
  if (zS(t)) return JS(qS(t, r));
  throw ZS(XS(r) + " is not iterable");
}, e1 = R, Fi = K, t1 = Pa, n1 = function(r, e, t) {
  var n, a;
  Fi(r);
  try {
    if (n = t1(r, "return"), !n) {
      if (e === "throw") throw t;
      return t;
    }
    n = e1(n, r);
  } catch (o) {
    a = !0, n = o;
  }
  if (e === "throw") throw t;
  if (a) throw n;
  return Fi(n), t;
}, a1 = se, o1 = R, i1 = K, s1 = ae, c1 = KS, u1 = kr, Bi = ne, l1 = r1, v1 = Nu, Ui = n1, f1 = TypeError, Be = function(r, e) {
  this.stopped = r, this.result = e;
}, Ki = Be.prototype, $e = function(r, e, t) {
  var n = t && t.that, a = !!(t && t.AS_ENTRIES), o = !!(t && t.IS_RECORD), i = !!(t && t.IS_ITERATOR), s = !!(t && t.INTERRUPTED), l = a1(e, n), c, u, v, f, d, p, y, $ = function(I) {
    return c && Ui(c, "normal", I), new Be(!0, I);
  }, b = function(I) {
    return a ? (i1(I), s ? l(I[0], I[1], $) : l(I[0], I[1])) : s ? l(I, $) : l(I);
  };
  if (o)
    c = r.iterator;
  else if (i)
    c = r;
  else {
    if (u = v1(r), !u) throw f1(s1(r) + " is not iterable");
    if (c1(u)) {
      for (v = 0, f = u1(r); f > v; v++)
        if (d = b(r[v]), d && Bi(Ki, d)) return d;
      return new Be(!1);
    }
    c = l1(r, u);
  }
  for (p = o ? r.next : c.next; !(y = o1(p, c)).done; ) {
    try {
      d = b(y.value);
    } catch (I) {
      Ui(c, "throw", I);
    }
    if (typeof d == "object" && d && Bi(Ki, d)) return d;
  }
  return new Be(!1);
}, d1 = Mr, p1 = function(r, e) {
  return r === void 0 ? arguments.length < 2 ? "" : e : d1(r);
}, $1 = g, h1 = ne, y1 = qa, He = Wc, g1 = OS, ku = ce, hn = nr, yn = fr, m1 = ES, b1 = MS, S1 = $e, O1 = p1, _1 = O, T1 = _1("toStringTag"), qe = Error, E1 = [].push, Rr = function(e, t) {
  var n = h1(gn, this), a;
  He ? a = He(qe(), n ? y1(this) : gn) : (a = n ? this : ku(gn), hn(a, T1, "Error")), t !== void 0 && hn(a, "message", O1(t)), b1(a, Rr, a.stack, 1), arguments.length > 2 && m1(a, arguments[2]);
  var o = [];
  return S1(e, E1, { that: o }), hn(a, "errors", o), a;
};
He ? He(Rr, qe) : g1(Rr, qe, { name: !0 });
var gn = Rr.prototype = ku(qe.prototype, {
  constructor: yn(1, Rr),
  message: yn(1, ""),
  name: yn(1, "AggregateError")
});
$1({ global: !0 }, {
  AggregateError: Rr
});
var ia = x, w1 = A, Mu = Function.prototype, I1 = ia && Object.getOwnPropertyDescriptor, Lu = w1(Mu, "name"), P1 = Lu && (function() {
}).name === "something";
Lu && (!ia || ia && I1(Mu, "name").configurable);
var R1 = {
  PROPER: P1
}, C1 = S, A1 = _, D1 = N, j1 = ce, Gi = qa, x1 = ve, N1 = O, sa = N1("iterator"), Fu = !1, q, mn, bn;
[].keys && (bn = [].keys(), "next" in bn ? (mn = Gi(Gi(bn)), mn !== Object.prototype && (q = mn)) : Fu = !0);
var k1 = !D1(q) || C1(function() {
  var r = {};
  return q[sa].call(r) !== r;
});
k1 ? q = {} : q = j1(q);
A1(q[sa]) || x1(q, sa, function() {
  return this;
});
var Bu = {
  IteratorPrototype: q,
  BUGGY_SAFARI_ITERATORS: Fu
}, M1 = Bu.IteratorPrototype, L1 = ce, F1 = fr, B1 = Lr, U1 = Fr, K1 = function() {
  return this;
}, G1 = function(r, e, t, n) {
  var a = e + " Iterator";
  return r.prototype = L1(M1, { next: F1(+!n, t) }), B1(r, a, !1, !0), U1[a] = K1, r;
}, V1 = g, W1 = R, Y1 = R1, H1 = G1, q1 = qa, z1 = Lr, Vi = ve, J1 = O, Wi = Fr, X1 = Bu, Q1 = Y1.PROPER, Re = X1.BUGGY_SAFARI_ITERATORS, Sn = J1("iterator"), Yi = "keys", Ce = "values", Hi = "entries", Z1 = function() {
  return this;
}, Uu = function(r, e, t, n, a, o, i) {
  H1(t, e, n);
  var s = function(b) {
    if (b === a && f) return f;
    if (!Re && b in u) return u[b];
    switch (b) {
      case Yi:
        return function() {
          return new t(this, b);
        };
      case Ce:
        return function() {
          return new t(this, b);
        };
      case Hi:
        return function() {
          return new t(this, b);
        };
    }
    return function() {
      return new t(this);
    };
  }, l = e + " Iterator", c = !1, u = r.prototype, v = u[Sn] || u["@@iterator"] || a && u[a], f = !Re && v || s(a), d = e === "Array" && u.entries || v, p, y, $;
  if (d && (p = q1(d.call(new r())), p !== Object.prototype && p.next && (z1(p, l, !0, !0), Wi[l] = Z1)), Q1 && a === Ce && v && v.name !== Ce && (c = !0, f = function() {
    return W1(v, this);
  }), a)
    if (y = {
      values: s(Ce),
      keys: o ? f : s(Yi),
      entries: s(Hi)
    }, i) for ($ in y)
      (Re || c || !($ in u)) && Vi(u, $, y[$]);
    else V1({ target: e, proto: !0, forced: Re || c }, y);
  return i && u[Sn] !== f && Vi(u, Sn, f, {}), Wi[e] = f, y;
}, Ku = function(r, e) {
  return { value: r, done: e };
}, rO = Q, qi = Fr, Gu = ft;
U.f;
var eO = Uu, Ae = Ku, Vu = "Array Iterator", tO = Gu.set, nO = Gu.getterFor(Vu);
eO(Array, "Array", function(r, e) {
  tO(this, {
    type: Vu,
    target: rO(r),
    // target
    index: 0,
    // next index
    kind: e
    // kind
  });
}, function() {
  var r = nO(this), e = r.target, t = r.kind, n = r.index++;
  if (!e || n >= e.length)
    return r.target = void 0, Ae(void 0, !0);
  switch (t) {
    case "keys":
      return Ae(n, !1);
    case "values":
      return Ae(e[n], !1);
  }
  return Ae([n, e[n]], !1);
}, "values");
qi.Arguments = qi.Array;
var aO = T, oO = vr, mt = oO(aO.process) === "process", iO = M, sO = tu, cO = O, uO = x, zi = cO("species"), lO = function(r) {
  var e = iO(r);
  uO && e && !e[zi] && sO(e, zi, {
    configurable: !0,
    get: function() {
      return this;
    }
  });
}, vO = ne, fO = TypeError, dO = function(r, e) {
  if (vO(e, r)) return r;
  throw fO("Incorrect invocation");
}, pO = Ua, $O = ae, hO = TypeError, yO = function(r) {
  if (pO(r)) return r;
  throw hO($O(r) + " is not a constructor");
}, Ji = K, gO = yO, mO = at, bO = O, SO = bO("species"), Wu = function(r, e) {
  var t = Ji(r).constructor, n;
  return t === void 0 || mO(n = Ji(t)[SO]) ? e : gO(n);
}, OO = TypeError, _O = function(r, e) {
  if (r < e) throw OO("Not enough arguments");
  return r;
}, TO = ot, Yu = /(?:ipad|iphone|ipod).*applewebkit/i.test(TO), j = T, EO = Ta, wO = se, Xi = _, IO = A, Hu = S, Qi = qc, PO = Ha, Zi = Aa, RO = _O, CO = Yu, AO = mt, ca = j.setImmediate, rs = j.clearImmediate, DO = j.process, On = j.Dispatch, jO = j.Function, es = j.MessageChannel, xO = j.String, _n = 0, Wr = {}, ts = "onreadystatechange", Qr, or, Tn, En;
Hu(function() {
  Qr = j.location;
});
var za = function(r) {
  if (IO(Wr, r)) {
    var e = Wr[r];
    delete Wr[r], e();
  }
}, wn = function(r) {
  return function() {
    za(r);
  };
}, ns = function(r) {
  za(r.data);
}, as = function(r) {
  j.postMessage(xO(r), Qr.protocol + "//" + Qr.host);
};
(!ca || !rs) && (ca = function(e) {
  RO(arguments.length, 1);
  var t = Xi(e) ? e : jO(e), n = PO(arguments, 1);
  return Wr[++_n] = function() {
    EO(t, void 0, n);
  }, or(_n), _n;
}, rs = function(e) {
  delete Wr[e];
}, AO ? or = function(r) {
  DO.nextTick(wn(r));
} : On && On.now ? or = function(r) {
  On.now(wn(r));
} : es && !CO ? (Tn = new es(), En = Tn.port2, Tn.port1.onmessage = ns, or = wO(En.postMessage, En)) : j.addEventListener && Xi(j.postMessage) && !j.importScripts && Qr && Qr.protocol !== "file:" && !Hu(as) ? (or = as, j.addEventListener("message", ns, !1)) : ts in Zi("script") ? or = function(r) {
  Qi.appendChild(Zi("script"))[ts] = function() {
    Qi.removeChild(this), za(r);
  };
} : or = function(r) {
  setTimeout(wn(r), 0);
});
var qu = {
  set: ca
}, zu = function() {
  this.head = null, this.tail = null;
};
zu.prototype = {
  add: function(r) {
    var e = { item: r, next: null }, t = this.tail;
    t ? t.next = e : this.head = e, this.tail = e;
  },
  get: function() {
    var r = this.head;
    if (r) {
      var e = this.head = r.next;
      return e === null && (this.tail = null), r.item;
    }
  }
};
var Ju = zu, NO = ot, kO = /ipad|iphone|ipod/i.test(NO) && typeof Pebble < "u", MO = ot, LO = /web0s(?!.*chrome)/i.test(MO), lr = T, os = se, FO = jr.f, In = qu.set, BO = Ju, UO = Yu, KO = kO, GO = LO, Pn = mt, is = lr.MutationObserver || lr.WebKitMutationObserver, ss = lr.document, cs = lr.process, De = lr.Promise, us = FO(lr, "queueMicrotask"), ua = us && us.value, mr, Rn, Cn, je, ls;
if (!ua) {
  var xe = new BO(), Ne = function() {
    var r, e;
    for (Pn && (r = cs.domain) && r.exit(); e = xe.get(); ) try {
      e();
    } catch (t) {
      throw xe.head && mr(), t;
    }
    r && r.enter();
  };
  !UO && !Pn && !GO && is && ss ? (Rn = !0, Cn = ss.createTextNode(""), new is(Ne).observe(Cn, { characterData: !0 }), mr = function() {
    Cn.data = Rn = !Rn;
  }) : !KO && De && De.resolve ? (je = De.resolve(void 0), je.constructor = De, ls = os(je.then, je), mr = function() {
    ls(Ne);
  }) : Pn ? mr = function() {
    cs.nextTick(Ne);
  } : (In = os(In, lr), mr = function() {
    In(Ne);
  }), ua = function(r) {
    xe.head || mr(), xe.add(r);
  };
}
var VO = ua, WO = function(r, e) {
  try {
    arguments.length === 1 ? console.error(r) : console.error(r, e);
  } catch {
  }
}, he = function(r) {
  try {
    return { error: !1, value: r() };
  } catch (e) {
    return { error: !0, value: e };
  }
}, YO = T, Br = YO.Promise, Xu = typeof Deno == "object" && Deno && typeof Deno.version == "object", HO = Xu, qO = mt, zO = !HO && !qO && typeof window == "object" && typeof document == "object", JO = T, Yr = Br, XO = _, QO = Gc, ZO = ou, r_ = O, e_ = zO, t_ = Xu, An = it, vs = Yr && Yr.prototype, n_ = r_("species"), fs = !1, Qu = XO(JO.PromiseRejectionEvent), a_ = QO("Promise", function() {
  var r = ZO(Yr), e = r !== String(Yr);
  if (!e && An === 66 || !(vs.catch && vs.finally)) return !0;
  if (!An || An < 51 || !/native code/.test(r)) {
    var t = new Yr(function(o) {
      o(1);
    }), n = function(o) {
      o(function() {
      }, function() {
      });
    }, a = t.constructor = {};
    if (a[n_] = n, fs = t.then(function() {
    }) instanceof n, !fs) return !0;
  }
  return !e && (e_ || t_) && !Qu;
}), ye = {
  CONSTRUCTOR: a_,
  REJECTION_EVENT: Qu
}, ar = {}, ds = Y, o_ = TypeError, i_ = function(r) {
  var e, t;
  this.promise = new r(function(n, a) {
    if (e !== void 0 || t !== void 0) throw o_("Bad Promise constructor");
    e = n, t = a;
  }), this.resolve = ds(e), this.reject = ds(t);
};
ar.f = function(r) {
  return new i_(r);
};
var s_ = g, ze = mt, er = T, ge = R, c_ = ve, u_ = Lr, l_ = lO, v_ = Y, la = _, f_ = N, d_ = dO, p_ = Wu, Zu = qu.set, Ja = VO, $_ = WO, h_ = he, y_ = Ju, rl = ft, va = Br, el = ye, tl = ar, bt = "Promise", nl = el.CONSTRUCTOR, g_ = el.REJECTION_EVENT, Dn = rl.getterFor(bt), m_ = rl.set, b_ = va && va.prototype, Or = va, jn = b_, al = er.TypeError, fa = er.document, Xa = er.process, da = tl.f, S_ = da, O_ = !!(fa && fa.createEvent && er.dispatchEvent), ol = "unhandledrejection", __ = "rejectionhandled", ps = 0, il = 1, T_ = 2, Qa = 1, sl = 2, ke, $s, E_, cl = function(r) {
  var e;
  return f_(r) && la(e = r.then) ? e : !1;
}, ul = function(r, e) {
  var t = e.value, n = e.state === il, a = n ? r.ok : r.fail, o = r.resolve, i = r.reject, s = r.domain, l, c, u;
  try {
    a ? (n || (e.rejection === sl && I_(e), e.rejection = Qa), a === !0 ? l = t : (s && s.enter(), l = a(t), s && (s.exit(), u = !0)), l === r.promise ? i(al("Promise-chain cycle")) : (c = cl(l)) ? ge(c, l, o, i) : o(l)) : i(t);
  } catch (v) {
    s && !u && s.exit(), i(v);
  }
}, ll = function(r, e) {
  r.notified || (r.notified = !0, Ja(function() {
    for (var t = r.reactions, n; n = t.get(); )
      ul(n, r);
    r.notified = !1, e && !r.rejection && w_(r);
  }));
}, vl = function(r, e, t) {
  var n, a;
  O_ ? (n = fa.createEvent("Event"), n.promise = e, n.reason = t, n.initEvent(r, !1, !0), er.dispatchEvent(n)) : n = { promise: e, reason: t }, !g_ && (a = er["on" + r]) ? a(n) : r === ol && $_("Unhandled promise rejection", t);
}, w_ = function(r) {
  ge(Zu, er, function() {
    var e = r.facade, t = r.value, n = hs(r), a;
    if (n && (a = h_(function() {
      ze ? Xa.emit("unhandledRejection", t, e) : vl(ol, e, t);
    }), r.rejection = ze || hs(r) ? sl : Qa, a.error))
      throw a.value;
  });
}, hs = function(r) {
  return r.rejection !== Qa && !r.parent;
}, I_ = function(r) {
  ge(Zu, er, function() {
    var e = r.facade;
    ze ? Xa.emit("rejectionHandled", e) : vl(__, e, r.value);
  });
}, _r = function(r, e, t) {
  return function(n) {
    r(e, n, t);
  };
}, Tr = function(r, e, t) {
  r.done || (r.done = !0, t && (r = t), r.value = e, r.state = T_, ll(r, !0));
}, pa = function(r, e, t) {
  if (!r.done) {
    r.done = !0, t && (r = t);
    try {
      if (r.facade === e) throw al("Promise can't be resolved itself");
      var n = cl(e);
      n ? Ja(function() {
        var a = { done: !1 };
        try {
          ge(
            n,
            e,
            _r(pa, a, r),
            _r(Tr, a, r)
          );
        } catch (o) {
          Tr(a, o, r);
        }
      }) : (r.value = e, r.state = il, ll(r, !1));
    } catch (a) {
      Tr({ done: !1 }, a, r);
    }
  }
};
nl && (Or = function(e) {
  d_(this, jn), v_(e), ge(ke, this);
  var t = Dn(this);
  try {
    e(_r(pa, t), _r(Tr, t));
  } catch (n) {
    Tr(t, n);
  }
}, jn = Or.prototype, ke = function(e) {
  m_(this, {
    type: bt,
    done: !1,
    notified: !1,
    parent: !1,
    reactions: new y_(),
    rejection: !1,
    state: ps,
    value: void 0
  });
}, ke.prototype = c_(jn, "then", function(e, t) {
  var n = Dn(this), a = da(p_(this, Or));
  return n.parent = !0, a.ok = la(e) ? e : !0, a.fail = la(t) && t, a.domain = ze ? Xa.domain : void 0, n.state === ps ? n.reactions.add(a) : Ja(function() {
    ul(a, n);
  }), a.promise;
}), $s = function() {
  var r = new ke(), e = Dn(r);
  this.promise = r, this.resolve = _r(pa, e), this.reject = _r(Tr, e);
}, tl.f = da = function(r) {
  return r === Or || r === E_ ? new $s(r) : S_(r);
});
s_({ global: !0, wrap: !0, forced: nl }, {
  Promise: Or
});
u_(Or, bt, !1, !0);
l_(bt);
var P_ = O, fl = P_("iterator"), dl = !1;
try {
  var R_ = 0, ys = {
    next: function() {
      return { done: !!R_++ };
    },
    return: function() {
      dl = !0;
    }
  };
  ys[fl] = function() {
    return this;
  }, Array.from(ys, function() {
    throw 2;
  });
} catch {
}
var C_ = function(r, e) {
  if (!e && !dl) return !1;
  var t = !1;
  try {
    var n = {};
    n[fl] = function() {
      return {
        next: function() {
          return { done: t = !0 };
        }
      };
    }, r(n);
  } catch {
  }
  return t;
}, A_ = Br, D_ = C_, j_ = ye.CONSTRUCTOR, St = j_ || !D_(function(r) {
  A_.all(r).then(void 0, function() {
  });
}), x_ = g, N_ = R, k_ = Y, M_ = ar, L_ = he, F_ = $e, B_ = St;
x_({ target: "Promise", stat: !0, forced: B_ }, {
  all: function(e) {
    var t = this, n = M_.f(t), a = n.resolve, o = n.reject, i = L_(function() {
      var s = k_(t.resolve), l = [], c = 0, u = 1;
      F_(e, function(v) {
        var f = c++, d = !1;
        u++, N_(s, t, v).then(function(p) {
          d || (d = !0, l[f] = p, --u || a(l));
        }, o);
      }), --u || a(l);
    });
    return i.error && o(i.value), n.promise;
  }
});
var U_ = g, K_ = ye.CONSTRUCTOR, gs = Br;
gs && gs.prototype;
U_({ target: "Promise", proto: !0, forced: K_, real: !0 }, {
  catch: function(r) {
    return this.then(void 0, r);
  }
});
var G_ = g, V_ = R, W_ = Y, Y_ = ar, H_ = he, q_ = $e, z_ = St;
G_({ target: "Promise", stat: !0, forced: z_ }, {
  race: function(e) {
    var t = this, n = Y_.f(t), a = n.reject, o = H_(function() {
      var i = W_(t.resolve);
      q_(e, function(s) {
        V_(i, t, s).then(n.resolve, a);
      });
    });
    return o.error && a(o.value), n.promise;
  }
});
var J_ = g, X_ = R, Q_ = ar, Z_ = ye.CONSTRUCTOR;
J_({ target: "Promise", stat: !0, forced: Z_ }, {
  reject: function(e) {
    var t = Q_.f(this);
    return X_(t.reject, void 0, e), t.promise;
  }
});
var rT = K, eT = N, tT = ar, pl = function(r, e) {
  if (rT(r), eT(e) && e.constructor === r) return e;
  var t = tT.f(r), n = t.resolve;
  return n(e), t.promise;
}, nT = g, aT = M, oT = N$, iT = Br, sT = ye.CONSTRUCTOR, cT = pl, uT = aT("Promise"), lT = !sT;
nT({ target: "Promise", stat: !0, forced: oT }, {
  resolve: function(e) {
    return cT(lT && this === uT ? iT : this, e);
  }
});
var vT = g, fT = R, dT = Y, pT = ar, $T = he, hT = $e, yT = St;
vT({ target: "Promise", stat: !0, forced: yT }, {
  allSettled: function(e) {
    var t = this, n = pT.f(t), a = n.resolve, o = n.reject, i = $T(function() {
      var s = dT(t.resolve), l = [], c = 0, u = 1;
      hT(e, function(v) {
        var f = c++, d = !1;
        u++, fT(s, t, v).then(function(p) {
          d || (d = !0, l[f] = { status: "fulfilled", value: p }, --u || a(l));
        }, function(p) {
          d || (d = !0, l[f] = { status: "rejected", reason: p }, --u || a(l));
        });
      }), --u || a(l);
    });
    return i.error && o(i.value), n.promise;
  }
});
var gT = g, mT = R, bT = Y, ST = M, OT = ar, _T = he, TT = $e, ET = St, ms = "No one promise resolved";
gT({ target: "Promise", stat: !0, forced: ET }, {
  any: function(e) {
    var t = this, n = ST("AggregateError"), a = OT.f(t), o = a.resolve, i = a.reject, s = _T(function() {
      var l = bT(t.resolve), c = [], u = 0, v = 1, f = !1;
      TT(e, function(d) {
        var p = u++, y = !1;
        v++, mT(l, t, d).then(function($) {
          y || f || (f = !0, o($));
        }, function($) {
          y || f || (y = !0, c[p] = $, --v || i(new n(c, ms)));
        });
      }), --v || i(new n(c, ms));
    });
    return s.error && i(s.value), a.promise;
  }
});
var wT = g, $a = Br, IT = S, PT = M, RT = _, CT = Wu, bs = pl, AT = $a && $a.prototype, DT = !!$a && IT(function() {
  AT.finally.call({ then: function() {
  } }, function() {
  });
});
wT({ target: "Promise", proto: !0, real: !0, forced: DT }, {
  finally: function(r) {
    var e = CT(this, PT("Promise")), t = RT(r);
    return this.then(
      t ? function(n) {
        return bs(e, r()).then(function() {
          return n;
        });
      } : r,
      t ? function(n) {
        return bs(e, r()).then(function() {
          throw n;
        });
      } : r
    );
  }
});
var Za = E, jT = ja, xT = Mr, NT = Ia, kT = Za("".charAt), Ss = Za("".charCodeAt), MT = Za("".slice), LT = function(r) {
  return function(e, t) {
    var n = xT(NT(e)), a = jT(t), o = n.length, i, s;
    return a < 0 || a >= o ? "" : (i = Ss(n, a), i < 55296 || i > 56319 || a + 1 === o || (s = Ss(n, a + 1)) < 56320 || s > 57343 ? kT(n, a) : MT(n, a, a + 2));
  };
}, FT = {
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: LT()
}, BT = FT.charAt, UT = Mr, $l = ft, KT = Uu, Os = Ku, hl = "String Iterator", GT = $l.set, VT = $l.getterFor(hl);
KT(String, "String", function(r) {
  GT(this, {
    type: hl,
    string: UT(r),
    index: 0
  });
}, function() {
  var e = VT(this), t = e.string, n = e.index, a;
  return n >= t.length ? Os(void 0, !0) : (a = BT(t, n), e.index += a.length, Os(a, !1));
});
var WT = k, YT = WT.Promise, HT = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
}, qT = HT, zT = T, JT = le, XT = nr, _s = Fr, QT = O, Ts = QT("toStringTag");
for (var xn in qT) {
  var Es = zT[xn], Nn = Es && Es.prototype;
  Nn && JT(Nn) !== Ts && XT(Nn, Ts, xn), _s[xn] = _s.Array;
}
var ZT = YT, rE = ZT, eE = rE, tE = /* @__PURE__ */ qp(eE), nE = TypeError, aE = 9007199254740991, oE = function(r) {
  if (r > aE) throw nE("Maximum allowed index exceeded");
  return r;
}, iE = S, sE = O, cE = it, uE = sE("species"), yl = function(r) {
  return cE >= 51 || !iE(function() {
    var e = [], t = e.constructor = {};
    return t[uE] = function() {
      return { foo: 1 };
    }, e[r](Boolean).foo !== 1;
  });
}, lE = g, vE = S, fE = dt, dE = N, pE = Nr, $E = kr, ws = oE, Is = Fa, hE = Bm, yE = yl, gE = O, mE = it, gl = gE("isConcatSpreadable"), bE = mE >= 51 || !vE(function() {
  var r = [];
  return r[gl] = !1, r.concat()[0] !== r;
}), SE = function(r) {
  if (!dE(r)) return !1;
  var e = r[gl];
  return e !== void 0 ? !!e : fE(r);
}, OE = !bE || !yE("concat");
lE({ target: "Array", proto: !0, forced: OE }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function(e) {
    var t = pE(this), n = hE(t, 0), a = 0, o, i, s, l, c;
    for (o = -1, s = arguments.length; o < s; o++)
      if (c = o === -1 ? t : arguments[o], SE(c))
        for (l = $E(c), ws(a + l), i = 0; i < l; i++, a++) i in c && Is(n, a, c[i]);
      else
        ws(a + 1), Is(n, a++, c);
    return n.length = a, n;
  }
});
var _E = D;
_E("asyncIterator");
var TE = D;
TE("hasInstance");
var EE = D;
EE("isConcatSpreadable");
var wE = D;
wE("iterator");
var IE = D;
IE("match");
var PE = D;
PE("matchAll");
var RE = D;
RE("replace");
var CE = D;
CE("search");
var AE = D;
AE("species");
var DE = D;
DE("split");
var jE = D, xE = nu;
jE("toPrimitive");
xE();
var NE = M, kE = D, ME = Lr;
kE("toStringTag");
ME(NE("Symbol"), "Symbol");
var LE = D;
LE("unscopables");
var FE = T, BE = Lr;
BE(FE.JSON, "JSON", !0);
var UE = k;
UE.Symbol;
var KE = fe;
KE.f("iterator");
var GE = Ma;
GE("Array").concat;
var VE = g, Ps = dt, WE = Ua, YE = N, Rs = xa, HE = kr, qE = Q, zE = Fa, JE = O, XE = yl, QE = Ha, ZE = XE("slice"), rw = JE("species"), kn = Array, ew = Math.max;
VE({ target: "Array", proto: !0, forced: !ZE }, {
  slice: function(e, t) {
    var n = qE(this), a = HE(n), o = Rs(e, a), i = Rs(t === void 0 ? a : t, a), s, l, c;
    if (Ps(n) && (s = n.constructor, WE(s) && (s === kn || Ps(s.prototype)) ? s = void 0 : YE(s) && (s = s[rw], s === null && (s = void 0)), s === kn || s === void 0))
      return QE(n, o, i);
    for (l = new (s === void 0 ? kn : s)(ew(i - o, 0)), c = 0; o < i; o++, c++) o in n && zE(l, c, n[o]);
    return l.length = c, l;
  }
});
var tw = Ma;
tw("Array").slice;
var nw = fe;
nw.f("asyncIterator");
function Mn(r, e, t, n) {
  function a(o) {
    return o instanceof t ? o : new t(function(i) {
      i(o);
    });
  }
  return new (t || (t = tE))(function(o, i) {
    function s(u) {
      try {
        c(n.next(u));
      } catch (v) {
        i(v);
      }
    }
    function l(u) {
      try {
        c(n.throw(u));
      } catch (v) {
        i(v);
      }
    }
    function c(u) {
      u.done ? o(u.value) : a(u.value).then(s, l);
    }
    c((n = n.apply(r, [])).next());
  });
}
class aw {
  /** Checks whether the app is running as an electron application. */
  isElectron() {
    var e;
    return window.electron ? !!window.electron : !!(!((e = process == null ? void 0 : process.versions) === null || e === void 0) && e.electron) || /electron/i.test(navigator.userAgent);
  }
  /**
   * Gets the electron version.
   *
   * version 0.0.0 represents a unsupported version
   */
  getVersion() {
    return Mn(this, void 0, void 0, function* () {
      return window.electron ? (yield window.electron.getVersion()).split("-")[0] : "0.0.0";
    });
  }
  /** Checks if the running Electron build is a standalone (non auto-updating windows version) */
  isStandaloneBuild() {
    return Mn(this, void 0, void 0, function* () {
      var e;
      return !((e = window.electron) === null || e === void 0) && e.isStandaloneBuild ? yield window.electron.isStandaloneBuild() : null;
    });
  }
  /** Checks if the running Electron build is installed from an windows MSI installer */
  isMsiBuild() {
    return Mn(this, void 0, void 0, function* () {
      var e;
      return !((e = window.electron) === null || e === void 0) && e.isMsiBuild ? yield window.electron.isMsiBuild() : null;
    });
  }
}
const Cs = new aw();
function ow(r, e) {
  return As(r), As(e), r.localeCompare(e, void 0, {
    numeric: !0
  });
}
function As(r) {
  if (r.split(".").length !== 3)
    throw Error(`The version '${r}' must be in the format 'x.x.x'.`);
}
const iw = Object.prototype.toString;
function sw(r, e) {
  return iw.call(r) === `[object ${e}]`;
}
function cw(r) {
  return sw(r, "Object");
}
function uw(r) {
  return !!(r && r.then && typeof r.then == "function");
}
const Hr = "8.36.0", J = globalThis;
function ro(r, e, t) {
  const n = t || J, a = n.__SENTRY__ = n.__SENTRY__ || {}, o = a[Hr] = a[Hr] || {};
  return o[r] || (o[r] = e());
}
const ml = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, lw = "Sentry Logger ", Ds = [
  "debug",
  "info",
  "warn",
  "error",
  "log",
  "assert",
  "trace"
], js = {};
function bl(r) {
  if (!("console" in J))
    return r();
  const e = J.console, t = {}, n = Object.keys(js);
  n.forEach((a) => {
    const o = js[a];
    t[a] = e[a], e[a] = o;
  });
  try {
    return r();
  } finally {
    n.forEach((a) => {
      e[a] = t[a];
    });
  }
}
function vw() {
  let r = !1;
  const e = {
    enable: () => {
      r = !0;
    },
    disable: () => {
      r = !1;
    },
    isEnabled: () => r
  };
  return ml ? Ds.forEach((t) => {
    e[t] = (...n) => {
      r && bl(() => {
        J.console[t](`${lw}[${t}]:`, ...n);
      });
    };
  }) : Ds.forEach((t) => {
    e[t] = () => {
    };
  }), e;
}
const Ue = ro("logger", vw);
function fw(r, e, t) {
  try {
    Object.defineProperty(r, e, {
      // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
      value: t,
      writable: !0,
      configurable: !0
    });
  } catch {
    ml && Ue.log(`Failed to add non-enumerable property "${e}" to object`, r);
  }
}
const Sl = 1e3;
function eo() {
  return Date.now() / Sl;
}
function dw() {
  const { performance: r } = J;
  if (!r || !r.now)
    return eo;
  const e = Date.now() - r.now(), t = r.timeOrigin == null ? e : r.timeOrigin;
  return () => (t + r.now()) / Sl;
}
const pw = dw();
(() => {
  const { performance: r } = J;
  if (!r || !r.now)
    return;
  const e = 3600 * 1e3, t = r.now(), n = Date.now(), a = r.timeOrigin ? Math.abs(r.timeOrigin + t - n) : e, o = a < e, i = r.timing && r.timing.navigationStart, l = typeof i == "number" ? Math.abs(i + t - n) : e, c = l < e;
  return o || c ? a <= l ? r.timeOrigin : i : n;
})();
function Er() {
  const r = J, e = r.crypto || r.msCrypto;
  let t = () => Math.random() * 16;
  try {
    if (e && e.randomUUID)
      return e.randomUUID().replace(/-/g, "");
    e && e.getRandomValues && (t = () => {
      const n = new Uint8Array(1);
      return e.getRandomValues(n), n[0];
    });
  } catch {
  }
  return ("10000000100040008000" + 1e11).replace(
    /[018]/g,
    (n) => (
      // eslint-disable-next-line no-bitwise
      (n ^ (t() & 15) >> n / 4).toString(16)
    )
  );
}
function xs() {
  return {
    traceId: Er(),
    spanId: Er().substring(16)
  };
}
function to() {
  return no(J), J;
}
function no(r) {
  const e = r.__SENTRY__ = r.__SENTRY__ || {};
  return e.version = e.version || Hr, e[Hr] = e[Hr] || {};
}
function $w(r, e = {}) {
  if (e.user && (!r.ipAddress && e.user.ip_address && (r.ipAddress = e.user.ip_address), !r.did && !e.did && (r.did = e.user.id || e.user.email || e.user.username)), r.timestamp = e.timestamp || pw(), e.abnormal_mechanism && (r.abnormal_mechanism = e.abnormal_mechanism), e.ignoreDuration && (r.ignoreDuration = e.ignoreDuration), e.sid && (r.sid = e.sid.length === 32 ? e.sid : Er()), e.init !== void 0 && (r.init = e.init), !r.did && e.did && (r.did = `${e.did}`), typeof e.started == "number" && (r.started = e.started), r.ignoreDuration)
    r.duration = void 0;
  else if (typeof e.duration == "number")
    r.duration = e.duration;
  else {
    const t = r.timestamp - r.started;
    r.duration = t >= 0 ? t : 0;
  }
  e.release && (r.release = e.release), e.environment && (r.environment = e.environment), !r.ipAddress && e.ipAddress && (r.ipAddress = e.ipAddress), !r.userAgent && e.userAgent && (r.userAgent = e.userAgent), typeof e.errors == "number" && (r.errors = e.errors), e.status && (r.status = e.status);
}
const ha = "_sentrySpan";
function Ns(r, e) {
  e ? fw(r, ha, e) : delete r[ha];
}
function ks(r) {
  return r[ha];
}
const hw = 100;
class ao {
  /** Flag if notifying is happening. */
  /** Callback for client to receive scope changes. */
  /** Callback list that will be called during event processing. */
  /** Array of breadcrumbs. */
  /** User */
  /** Tags */
  /** Extra */
  /** Contexts */
  /** Attachments */
  /** Propagation Context for distributed tracing */
  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */
  /** Fingerprint */
  /** Severity */
  /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */
  /** Session */
  /** Request Mode Session Status */
  /** The client on this scope */
  /** Contains the last event id of a captured event.  */
  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
  constructor() {
    this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._attachments = [], this._user = {}, this._tags = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {}, this._propagationContext = xs();
  }
  /**
   * @inheritDoc
   */
  clone() {
    const e = new ao();
    return e._breadcrumbs = [...this._breadcrumbs], e._tags = { ...this._tags }, e._extra = { ...this._extra }, e._contexts = { ...this._contexts }, e._user = this._user, e._level = this._level, e._session = this._session, e._transactionName = this._transactionName, e._fingerprint = this._fingerprint, e._eventProcessors = [...this._eventProcessors], e._requestSession = this._requestSession, e._attachments = [...this._attachments], e._sdkProcessingMetadata = { ...this._sdkProcessingMetadata }, e._propagationContext = { ...this._propagationContext }, e._client = this._client, e._lastEventId = this._lastEventId, Ns(e, ks(this)), e;
  }
  /**
   * @inheritDoc
   */
  setClient(e) {
    this._client = e;
  }
  /**
   * @inheritDoc
   */
  setLastEventId(e) {
    this._lastEventId = e;
  }
  /**
   * @inheritDoc
   */
  getClient() {
    return this._client;
  }
  /**
   * @inheritDoc
   */
  lastEventId() {
    return this._lastEventId;
  }
  /**
   * @inheritDoc
   */
  addScopeListener(e) {
    this._scopeListeners.push(e);
  }
  /**
   * @inheritDoc
   */
  addEventProcessor(e) {
    return this._eventProcessors.push(e), this;
  }
  /**
   * @inheritDoc
   */
  setUser(e) {
    return this._user = e || {
      email: void 0,
      id: void 0,
      ip_address: void 0,
      username: void 0
    }, this._session && $w(this._session, { user: e }), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getUser() {
    return this._user;
  }
  /**
   * @inheritDoc
   */
  getRequestSession() {
    return this._requestSession;
  }
  /**
   * @inheritDoc
   */
  setRequestSession(e) {
    return this._requestSession = e, this;
  }
  /**
   * @inheritDoc
   */
  setTags(e) {
    return this._tags = {
      ...this._tags,
      ...e
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTag(e, t) {
    return this._tags = { ...this._tags, [e]: t }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtras(e) {
    return this._extra = {
      ...this._extra,
      ...e
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtra(e, t) {
    return this._extra = { ...this._extra, [e]: t }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setFingerprint(e) {
    return this._fingerprint = e, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setLevel(e) {
    return this._level = e, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTransactionName(e) {
    return this._transactionName = e, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setContext(e, t) {
    return t === null ? delete this._contexts[e] : this._contexts[e] = t, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setSession(e) {
    return e ? this._session = e : delete this._session, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getSession() {
    return this._session;
  }
  /**
   * @inheritDoc
   */
  update(e) {
    if (!e)
      return this;
    const t = typeof e == "function" ? e(this) : e, [n, a] = t instanceof Cr ? [t.getScopeData(), t.getRequestSession()] : cw(t) ? [e, e.requestSession] : [], { tags: o, extra: i, user: s, contexts: l, level: c, fingerprint: u = [], propagationContext: v } = n || {};
    return this._tags = { ...this._tags, ...o }, this._extra = { ...this._extra, ...i }, this._contexts = { ...this._contexts, ...l }, s && Object.keys(s).length && (this._user = s), c && (this._level = c), u.length && (this._fingerprint = u), v && (this._propagationContext = v), a && (this._requestSession = a), this;
  }
  /**
   * @inheritDoc
   */
  clear() {
    return this._breadcrumbs = [], this._tags = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._requestSession = void 0, this._session = void 0, Ns(this, void 0), this._attachments = [], this._propagationContext = xs(), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addBreadcrumb(e, t) {
    const n = typeof t == "number" ? t : hw;
    if (n <= 0)
      return this;
    const a = {
      timestamp: eo(),
      ...e
    }, o = this._breadcrumbs;
    return o.push(a), this._breadcrumbs = o.length > n ? o.slice(-n) : o, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }
  /**
   * @inheritDoc
   */
  clearBreadcrumbs() {
    return this._breadcrumbs = [], this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addAttachment(e) {
    return this._attachments.push(e), this;
  }
  /**
   * @inheritDoc
   */
  clearAttachments() {
    return this._attachments = [], this;
  }
  /** @inheritDoc */
  getScopeData() {
    return {
      breadcrumbs: this._breadcrumbs,
      attachments: this._attachments,
      contexts: this._contexts,
      tags: this._tags,
      extra: this._extra,
      user: this._user,
      level: this._level,
      fingerprint: this._fingerprint || [],
      eventProcessors: this._eventProcessors,
      propagationContext: this._propagationContext,
      sdkProcessingMetadata: this._sdkProcessingMetadata,
      transactionName: this._transactionName,
      span: ks(this)
    };
  }
  /**
   * @inheritDoc
   */
  setSDKProcessingMetadata(e) {
    return this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...e }, this;
  }
  /**
   * @inheritDoc
   */
  setPropagationContext(e) {
    return this._propagationContext = e, this;
  }
  /**
   * @inheritDoc
   */
  getPropagationContext() {
    return this._propagationContext;
  }
  /**
   * @inheritDoc
   */
  captureException(e, t) {
    const n = t && t.event_id ? t.event_id : Er();
    if (!this._client)
      return Ue.warn("No client configured on scope - will not capture exception!"), n;
    const a = new Error("Sentry syntheticException");
    return this._client.captureException(
      e,
      {
        originalException: e,
        syntheticException: a,
        ...t,
        event_id: n
      },
      this
    ), n;
  }
  /**
   * @inheritDoc
   */
  captureMessage(e, t, n) {
    const a = n && n.event_id ? n.event_id : Er();
    if (!this._client)
      return Ue.warn("No client configured on scope - will not capture message!"), a;
    const o = new Error(e);
    return this._client.captureMessage(
      e,
      t,
      {
        originalException: e,
        syntheticException: o,
        ...n,
        event_id: a
      },
      this
    ), a;
  }
  /**
   * @inheritDoc
   */
  captureEvent(e, t) {
    const n = t && t.event_id ? t.event_id : Er();
    return this._client ? (this._client.captureEvent(e, { ...t, event_id: n }, this), n) : (Ue.warn("No client configured on scope - will not capture event!"), n);
  }
  /**
   * This will be called on every set call.
   */
  _notifyScopeListeners() {
    this._notifyingListeners || (this._notifyingListeners = !0, this._scopeListeners.forEach((e) => {
      e(this);
    }), this._notifyingListeners = !1);
  }
}
const Cr = ao;
function yw() {
  return ro("defaultCurrentScope", () => new Cr());
}
function gw() {
  return ro("defaultIsolationScope", () => new Cr());
}
class mw {
  constructor(e, t) {
    let n;
    e ? n = e : n = new Cr();
    let a;
    t ? a = t : a = new Cr(), this._stack = [{ scope: n }], this._isolationScope = a;
  }
  /**
   * Fork a scope for the stack.
   */
  withScope(e) {
    const t = this._pushScope();
    let n;
    try {
      n = e(t);
    } catch (a) {
      throw this._popScope(), a;
    }
    return uw(n) ? n.then(
      (a) => (this._popScope(), a),
      (a) => {
        throw this._popScope(), a;
      }
    ) : (this._popScope(), n);
  }
  /**
   * Get the client of the stack.
   */
  getClient() {
    return this.getStackTop().client;
  }
  /**
   * Returns the scope of the top stack.
   */
  getScope() {
    return this.getStackTop().scope;
  }
  /**
   * Get the isolation scope for the stack.
   */
  getIsolationScope() {
    return this._isolationScope;
  }
  /**
   * Returns the topmost scope layer in the order domain > local > process.
   */
  getStackTop() {
    return this._stack[this._stack.length - 1];
  }
  /**
   * Push a scope to the stack.
   */
  _pushScope() {
    const e = this.getScope().clone();
    return this._stack.push({
      client: this.getClient(),
      scope: e
    }), e;
  }
  /**
   * Pop a scope from the stack.
   */
  _popScope() {
    return this._stack.length <= 1 ? !1 : !!this._stack.pop();
  }
}
function Ar() {
  const r = to(), e = no(r);
  return e.stack = e.stack || new mw(yw(), gw());
}
function bw(r) {
  return Ar().withScope(r);
}
function Sw(r, e) {
  const t = Ar();
  return t.withScope(() => (t.getStackTop().scope = r, e(r)));
}
function Ms(r) {
  return Ar().withScope(() => r(Ar().getIsolationScope()));
}
function Ow() {
  return {
    withIsolationScope: Ms,
    withScope: bw,
    withSetScope: Sw,
    withSetIsolationScope: (r, e) => Ms(e),
    getCurrentScope: () => Ar().getScope(),
    getIsolationScope: () => Ar().getIsolationScope()
  };
}
function Ol(r) {
  const e = no(r);
  return e.acs ? e.acs : Ow();
}
function oo() {
  const r = to();
  return Ol(r).getCurrentScope();
}
function _l() {
  const r = to();
  return Ol(r).getIsolationScope();
}
function _w() {
  return oo().getClient();
}
function Tw(r) {
  if (r)
    return Ew(r) ? { captureContext: r } : Iw(r) ? {
      captureContext: r
    } : r;
}
function Ew(r) {
  return r instanceof Cr || typeof r == "function";
}
const ww = [
  "user",
  "level",
  "extra",
  "contexts",
  "tags",
  "fingerprint",
  "requestSession",
  "propagationContext"
];
function Iw(r) {
  return Object.keys(r).some((e) => ww.includes(e));
}
function Ls(r, e) {
  return oo().captureException(r, Tw(e));
}
function Pw(r, e) {
  const t = typeof e == "string" ? e : void 0, n = typeof e != "string" ? { captureContext: e } : void 0;
  return oo().captureMessage(r, t, n);
}
function Rw(r, e) {
  _l().setContext(r, e);
}
const Cw = 100;
function sr(r, e) {
  const t = _w(), n = _l();
  if (!t) return;
  const { beforeBreadcrumb: a = null, maxBreadcrumbs: o = Cw } = t.getOptions();
  if (o <= 0) return;
  const s = { timestamp: eo(), ...r }, l = a ? bl(() => a(s, e)) : s;
  l !== null && (t.emit && t.emit("beforeAddBreadcrumb", l, e), n.addBreadcrumb(l, o));
}
var Zr;
(function(r) {
  r.Unknown = "unknown", r.Core = "core", r.Routing = "routing-and-presence", r.Insights = "insights", r.Ecosystem = "ecosystem", r.Partners = "partners", r.Channels = "channels", r.Messaging = "messaging", r.Platform = "platform", r.AI = "ai", r.Conversations = "conversations", r.Automation = "automation";
})(Zr || (Zr = {}));
function wr(r) {
  const e = r.split(".")[1];
  if (!e)
    throw Error("Invalid token");
  const t = e.replace(/-/g, "+").replace(/_/g, "/");
  try {
    return JSON.parse(Buffer.from(t, "base64").toString());
  } catch (n) {
    throw Error(`Failed to parse the JSON Web Token with the following error: ${n}`);
  }
}
const Aw = qr.backendDomain ? {
  "backend-domain": qr.backendDomain
} : void 0;
function Ke() {
  const r = new URLSearchParams(Object.assign({ noToken: "true" }, Aw)).toString();
  document.location.href = `${qr.url.logIn}?${r}`;
}
const Ln = "authData", Fn = 30, Dw = 600, Bn = 5;
class jw {
  constructor() {
    Object.defineProperty(this, "authData", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: null
    }), Object.defineProperty(this, "accessTokenExpiresAt", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 0
    }), Object.defineProperty(this, "clientServerTimeDiff", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 0
    });
  }
  /**
   * Returns an estimated server time (unix epoch in seconds) by adding the
   * client-server time difference to the current client time.
   *
   * The time-diff is stored whenever a new access token is saved.
   *
   * @returns {number} The estimated server time in seconds.
   */
  estimatedServerTime() {
    const e = Date.now() / 1e3;
    return this.clientServerTimeDiff >= Bn || this.clientServerTimeDiff <= -Bn ? Math.ceil(e + this.clientServerTimeDiff) : Math.ceil(e);
  }
  /**
   * Sets the auth data in localStorage.
   *
   * @param authData The auth data.
   */
  setAuthData(e) {
    this.authData = e;
    const n = Math.ceil(Date.now() / 1e3) + Dw, a = wr(e.access_token).exp;
    if (this.clientServerTimeDiff = a - n, process.env.NODE_ENV !== "test" && Math.abs(this.clientServerTimeDiff) > Bn) {
      const o = this.clientServerTimeDiff > 0 ? "behind" : "ahead";
      console.info(`Client time is ${o} by significant amount. (${Math.abs(this.clientServerTimeDiff)}s)`);
    }
    this.accessTokenExpiresAt = a, localStorage.setItem(Ln, JSON.stringify(e));
  }
  /** Gets the auth data from memory or localStorage. */
  getAuthData() {
    if (this.authData)
      return this.authData;
    const e = localStorage.getItem(Ln), t = e ? JSON.parse(e) : null;
    return this.validateAuthDataComplete(t) && (this.authData = t), t;
  }
  /** Removes the auth data from localStorage. */
  removeAuthData() {
    this.authData = null, localStorage.removeItem(Ln);
  }
  getAccessToken() {
    var e;
    return ((e = this.authData) === null || e === void 0 ? void 0 : e.access_token) || null;
  }
  getRefreshToken() {
    var e;
    return ((e = this.authData) === null || e === void 0 ? void 0 : e.refresh_token) || null;
  }
  /**
   * Validates that the auth data is complete - i.e not fragmented.
   *
   * @param authData The auth data.
   */
  validateAuthDataComplete(e) {
    return e ? [
      "access_token",
      "refresh_token",
      "expires_in"
    ].every((n) => typeof e[n] < "u") : !1;
  }
  isAccessTokenExpired() {
    if (!this.getAccessToken())
      return !0;
    const t = this.accessTokenExpiresAt - Fn;
    return this.estimatedServerTime() >= t;
  }
  isRefreshTokenExpired(e) {
    if (!e)
      return !0;
    const t = wr(e), n = t.exp - Fn;
    return !t || this.estimatedServerTime() >= n;
  }
  accessTokenExpiresInMs() {
    return (this.accessTokenExpiresAt - Fn - this.estimatedServerTime()) * 1e3;
  }
}
const P = new jw();
var xw = function(r, e, t, n) {
  function a(o) {
    return o instanceof t ? o : new t(function(i) {
      i(o);
    });
  }
  return new (t || (t = Promise))(function(o, i) {
    function s(u) {
      try {
        c(n.next(u));
      } catch (v) {
        i(v);
      }
    }
    function l(u) {
      try {
        c(n.throw(u));
      } catch (v) {
        i(v);
      }
    }
    function c(u) {
      u.done ? o(u.value) : a(u.value).then(s, l);
    }
    c((n = n.apply(r, e || [])).next());
  });
};
function Nw(r) {
  return xw(this, void 0, void 0, function* () {
    var e, t;
    const n = window.location.origin.replace(/^https?:\/\//, ""), a = ["localhost:8080", "uptrends-monitor"];
    if (!(!r.response || a.some((o) => n.includes(o)))) {
      try {
        const o = (e = r.response.config.headers.Authorization) !== null && e !== void 0 ? e : "", i = o ? (t = o.toString()) === null || t === void 0 ? void 0 : t.split("Basic ")[1] : "", s = i ? atob(i).split("token:")[1] : "", l = s ? wr(s).exp : "None", c = yield io.getAuthData({ localStorageOnly: !0 }), u = Math.floor(Date.now() / 1e3), v = c?.access_token, f = c?.refresh_token, d = v ? wr(v).exp : "None", p = f ? wr(f).exp : "None", y = typeof l == "number" ? u - l : "Unknown", $ = typeof d == "number" ? u - d : "Unknown", b = typeof p == "number" ? u - p : "Unknown", I = r.response.headers["x-dixa-rid"];
        Rw("Expires", {
          currentTimestamp: u,
          accessTokenFromHeader: l,
          accessTokenFromHeaderDiff: y,
          accessTokenFromLocalStorage: d,
          accessTokenFromLocalStorageDiff: $,
          refreshTokenFromLocalStorage: p,
          refreshTokenFromLocalStorageDiff: b,
          xDixaRid: I,
          navigatorOnline: navigator.onLine
        });
      } catch (o) {
        console.error("Error adding Sentry error context", o);
      }
      Pw("401 unauthorized interceptor", {
        level: "debug",
        tags: {
          team: Zr.Platform,
          domain: n
        }
      });
    }
  });
}
const Un = /* @__PURE__ */ new Map(), kw = 3;
function Mw(r) {
  r.interceptors.response.use((e) => (Un.delete(e.config.url), e), (e) => {
    var t;
    if (e.response) {
      const { status: n } = e.response;
      switch (n) {
        case ya.Unauthorized:
          if (!io.isRefreshTokenExpired() && e.config) {
            sr({
              category: "errorInterceptor",
              message: "Access token expired after request",
              level: "debug"
            });
            const a = (t = Un.get(e.config.url)) !== null && t !== void 0 ? t : 0;
            if (console.log(`Retrying request (${a + 1}): ${e.config.url}`), a <= kw)
              return Un.set(e.config.url, a + 1), r(e.config);
          }
          Nw(e), console.error("401 unauthorized interceptor"), Ke();
          break;
      }
    }
    return Promise.reject(e);
  });
}
var Z = function(r, e, t, n) {
  function a(o) {
    return o instanceof t ? o : new t(function(i) {
      i(o);
    });
  }
  return new (t || (t = Promise))(function(o, i) {
    function s(u) {
      try {
        c(n.next(u));
      } catch (v) {
        i(v);
      }
    }
    function l(u) {
      try {
        c(n.throw(u));
      } catch (v) {
        i(v);
      }
    }
    function c(u) {
      u.done ? o(u.value) : a(u.value).then(s, l);
    }
    c((n = n.apply(r, e || [])).next());
  });
};
const Tl = Bs.create();
Mw(Tl);
const H = console.log;
function Fs(r) {
  return Z(this, void 0, void 0, function* () {
    return new Promise((e) => setTimeout(e, r * 1e3));
  });
}
class Lw extends Error {
  constructor(e, t) {
    super(e, t);
  }
}
function Fw(r = 0) {
  return Math.min(Math.round((Math.random() + 1) * Math.pow(1.5, r)), 30);
}
const Bw = 5;
class Uw {
  constructor() {
    Object.defineProperty(this, "authDataPromise", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: null
    }), Object.defineProperty(this, "retryCount", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 0
    });
  }
  init(e) {
    return Z(this, void 0, void 0, function* () {
      const t = yield this.refresh(e);
      if (t)
        P.setAuthData(t);
      else {
        const n = P.isRefreshTokenExpired(e) ? "expired" : "unknown";
        throw new Lw("Failed to init refresh token", {
          cause: n
        });
      }
    });
  }
  getDebugInfo() {
    const e = P.getAccessToken();
    if (!e)
      return {};
    const t = wr(e), { exp: n } = t;
    return {
      expire: n ? new Date(n * 1e3).toISOString() : null,
      now: (/* @__PURE__ */ new Date()).toISOString()
    };
  }
  /**
   * Gets auth data from LocalStorage, or fetches new auth data if the current
   * token is expired or is about to expire.
   */
  getAuthData() {
    return Z(this, arguments, void 0, function* ({ localStorageOnly: e = !1 } = {}) {
      if (e)
        return P.getAuthData();
      if (this.authDataPromise)
        return yield this.authDataPromise;
      const t = P.getAuthData();
      return t ? P.isAccessTokenExpired() ? (sr({
        category: "refreshToken",
        // Cannot include "token" in the message, as it will be redacted
        message: "expired or about to expire",
        level: "debug",
        data: this.getDebugInfo()
      }), this.authDataPromise = this.refresh(t.refresh_token).then((n) => (n && P.setAuthData(n), this.authDataPromise = null, n)), yield this.authDataPromise) : t : null;
    });
  }
  removeAuthData() {
    return P.removeAuthData();
  }
  validateAuthDataComplete(e) {
    return P.validateAuthDataComplete(e);
  }
  isAccessTokenExpired() {
    return P.isAccessTokenExpired();
  }
  isRefreshTokenExpired() {
    const e = P.getAuthData();
    return e ? P.isRefreshTokenExpired(e.refresh_token) : !0;
  }
  /** Checks whether refresh token is supported. */
  isSupported() {
    return Z(this, void 0, void 0, function* () {
      if (!Cs.isElectron())
        return !0;
      const e = yield Cs.getVersion();
      return ow(e, "3.7.0") === 1;
    });
  }
  /**
   * Gets refreshed tokens from the API
   *
   * @param refreshToken The refresh token.
   * @param retriesLeft The number of retries left.
   */
  refresh(e) {
    return Z(this, arguments, void 0, function* (t, n = Bw) {
      try {
        return yield Tl.post(`${qr.url.rest}/v2/login/refresh`, {
          refreshToken: t
        }).then((a) => (this.retryCount = 0, a.data.data));
      } catch (a) {
        return yield this.handleRefreshError(a, t, n);
      }
    });
  }
  waitUntilOnline() {
    return Z(this, void 0, void 0, function* () {
      const e = navigator.onLine === !1;
      for (e && (H("AUTH", "Network connection offline - waiting..."), sr({
        category: "refreshToken",
        message: "Network connection offline - waiting...",
        level: "debug"
      })); navigator.onLine === !1; )
        yield Fs(5);
      e && (H("AUTH", "Network connection restored"), sr({
        category: "refreshToken",
        message: "Network connection restored",
        level: "debug"
      }));
    });
  }
  retryRefresh(e, t) {
    return Z(this, void 0, void 0, function* () {
      yield this.waitUntilOnline(), this.retryCount++;
      const n = Fw(this.retryCount);
      return H("AUTH", `Retrying in ${n} seconds`), yield Fs(n), yield this.refresh(e, t);
    });
  }
  handleRefreshError(e, t, n) {
    return Z(this, void 0, void 0, function* () {
      var a;
      if (P.isRefreshTokenExpired(t))
        return H("AUTH", "Refresh token expired"), sr({
          category: "refreshToken",
          message: "Refresh token expired",
          level: "debug"
        }), P.removeAuthData(), Ke(), null;
      if (El(e)) {
        if (e.message === "timeout exceeded")
          return H("AUTH", "Timeout exceeded"), sr({
            category: "refreshToken",
            message: "Timeout exceeded",
            level: "debug"
          }), yield this.retryRefresh(t, n);
        if (e.message === "Network Error")
          return H("AUTH", "Network error"), sr({
            category: "refreshToken",
            message: "Network error",
            level: "debug"
          }), yield this.retryRefresh(t, n);
        if (((a = e.response) === null || a === void 0 ? void 0 : a.status) === 401)
          return H("AUTH", "Refresh token invalid (401)"), P.removeAuthData(), Ke(), null;
        Ls(e, {
          level: "error",
          tags: {
            team: Zr.Platform,
            errorSource: "authManager.refresh"
          }
        });
      }
      return n <= 0 ? (H("AUTH", "Retries exhausted, logging out"), Ls(e, {
        level: "error",
        tags: {
          team: Zr.Platform,
          errorSource: "authManager.refresh"
        }
      }), P.removeAuthData(), Ke(), null) : (H("AUTH", `Retrying ${n} more times`), yield this.retryRefresh(t, n - 1));
    });
  }
  accessTokenExpiresInMs() {
    return P.accessTokenExpiresInMs();
  }
}
const io = new Uw();
var ya;
(function(r) {
  r[r.BadRequest = 400] = "BadRequest", r[r.Unauthorized = 401] = "Unauthorized", r[r.Forbidden = 403] = "Forbidden", r[r.NotFound = 404] = "NotFound", r[r.Conflict = 409] = "Conflict", r[r.InternalServerError = 500] = "InternalServerError", r[r.BadGateway = 502] = "BadGateway", r[r.ServiceUnavailable = 503] = "ServiceUnavailable";
})(ya || (ya = {}));
const Kw = Bs.create();
class Gw {
  /** The current logged in user. */
  user = null;
  /** The list of authorization scopes assigned to the current user. */
  scopes = null;
  /** This list of user roles assigned to the current user */
  _roles = null;
  /** Checks if the service has been initialized. */
  get isInitialized() {
    return this.user !== null;
  }
  /** Initializes the access control service. */
  async init({
    user: e
  }) {
    this.user = e;
    const t = await this.introspectAccessToken();
    t && (this.scopes = t.scope, this._roles = t.roles);
  }
  /** Exposed read-only list of user roles assigned to the current user */
  get roles() {
    return this._roles;
  }
  /**
   * Checks if the current user has access to one or more scopes.
   *
   * @param scopes - The scope(s) to check.
   * @param options - The options to use when checking multiple scopes.
   * @param options.strategy - The strategy to use when checking multiple
   *   scopes. Can be "all" or "any".
   * @returns Whether or not the user has access to the scope(s).
   */
  hasAccess(e, t) {
    if (!this.isInitialized || this.scopes === null)
      return !1;
    if (Array.isArray(e)) {
      const { strategy: n = "all" } = t ?? {};
      return n === "all" ? e.every(this.hasScope) : e.some(this.hasScope);
    }
    return this.scopes.includes(e);
  }
  /** Checks if the user has a certain scope. */
  hasScope = (e) => this.scopes.includes(e);
  /**
   * Fetches the introspection data of the current access_token and stores it in
   * memory. This should be called only once on init.
   */
  async introspectAccessToken() {
    const e = await io.getAuthData({ localStorageOnly: !0 });
    if (!e) return null;
    try {
      return (await Kw.post(
        `${qr.url.rest}/v1/introspect`,
        {
          token: e.access_token
        },
        {
          transformResponse: (n) => {
            const a = JSON.parse(n);
            return {
              ...a,
              /**
               * As per the spec, the backend returns the `scope` as a
               * space-separated string. We convert it to an array of strings to
               * make it easier for us.
               *
               * @see https://datatracker.ietf.org/doc/html/rfc7662#section-2.2
               */
              scope: a.scope ? a.scope.split(" ") : []
            };
          }
        }
      )).data;
    } catch {
      return null;
    }
  }
  reset() {
    this.user = null, this.scopes = null, this._roles = null;
  }
}
const Vw = new Gw(), Hw = (r, e) => wl(
  () => Vw.hasAccess(r, e),
  // The arguments are statically defined when consuming the hook, therefore we don't need to
  // recompute the result on every render.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []
);
export {
  Vw as accessControl,
  Hw as useHasAccess
};
//# sourceMappingURL=index.js.map
